import { DeviceName } from './../../../constant/device.constant';
import {
  Component,
  ComponentFactoryResolver,
  HostListener,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { PageConstant } from '../../../constant/page.constant';
import { Router } from '@angular/router';
import { LanguageConstant } from '../../../constant/language.constant';
import { GameConstant } from '../../../constant/game.constant';
import { LoadGameService } from '../../../services/load.game.service';
import { FC21Lobby } from '../../../models/fc21lobby';
import { FCBLobby } from '../../../models/fcblobby';
import { GameTypeConstant } from '../../../constant/game.type.constant';
import { SelectInfoLayoutDesktopComponent } from '../../../module/selectinfo/desktop/selectinfo.layout.desktop.component';
import { SelectHistoryLayoutDesktopComponent } from '../../../module/selecthistory/desktop/selecthistory.layout.desktop.component';
import { SelectSettingsLayoutDesktopComponent } from '../../../module/selectsettings/desktop/selectsettings.layout.desktop.component';
import { TutorialConstant } from '../../../constant/tutorial.constant';
import { TutorialLayoutDesktopComponent } from '../../../module/tutorial/desktop/tutorial.layout.desktop.component';
import { BetlimitService } from '../../../services/betlimit.service';
import { TableInfopopupLayoutDesktopComponent } from '../../../module/tableinfopopup/desktop/tableinfopopup.layout.desktop.component';
import { FeatureConstant } from '../../../constant/feature.constant';
import { GIInfoService } from '../../../services/giinfo.service';
import { ComingSoonLayoutDesktopComponent } from '../../../module/comingsoon/desktop/comingsoon.layout.desktop.component';
import { SelectLanguageLayoutDesktopComponent } from '../../../module/selectlanguage/desktop/selectlanguage.layout.desktop.component';
import {
  ErrorData,
  ErrorPopupService,
} from '../../../services/error.popup.service';
import { AppErrorLayoutDesktopComponent } from '../../../module/apperror/desktop/apperror.layout.desktop.component';
import { FC21RTP } from '../../../models/fc21rtp';
import { MenuListConstant } from '../../../constant/menu.list.constant';
import { Menu } from '../../../models/menu';
import { API } from '../../../constant/api';
import { TableinfopopupLayoutMobileComponent } from '../../../module/tableinfopopup/mobile/tableinfopopup.layout.mobile.component';
import { SelectSymbolsLayoutDesktopComponent } from '../../../module/selectsymbols/desktop/selectsymbols.layout.desktop.component';
import { Settings } from '../../../models/settings/settings';
import { FC21 } from '../../../models/settings/fc21';
import { FCB } from '../../../models/settings/fcb';
import { FavoriteInfoLayoutDesktopComponent } from '../../../module/favoriteinfo/desktop/favoriteinfo.layout.desktop.component';
import { UtilService } from '../../../util/UtilService';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { TableLimitsLayoutDesktopComponent } from '../../../module/tablelimits/desktop/tablelimits.layout.desktop.component';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';
import { FirebaseConstant } from '../../../constant/firebase.constant';
import { UserService } from '../../../services/user.service';
import { PlayForFunAlertLayoutMobileComponent } from '../../../module/playforfunalert/mobile/playforfunalert.layout.mobile.component';
import { AlertPlayerRegisterPopupMobileComponent } from 'src/app/module/alertPlayerRegisterPopup/mobile/alertPlayerRegisterPopup.layout.mobile.component';
import { alertInsufficientPopupMobileComponent } from 'src/app/module/alertInsufficientPopup/mobile/alertInsufficientPopup.layout.mobile.component';
import { alertLiveDealerNoSeatAvailableComponent } from 'src/app/module/alertlivedealernoseatavailable/mobile/alertlivedealernoseatavailable.layout.mobile.component';
import { send } from '@rlx/feim';
import { BetLimitPopupComponent } from 'src/app/module/betlimitpopup/components/betlimitpopup.component';
import {
  getGameIdFromUrl,
  getGameParameters,
  tableTypeMap,
} from 'src/app/services/game-id.service';
import { getQueryStrings } from 'src/app/app.component';
import * as Sentry from '@sentry/angular';

@Component({
  templateUrl: '../../../template/noop.template.html',
  standalone: false,
})
export class CommonLayoutComponent implements OnInit, OnDestroy {
  private changeReportTimeOut;
  private changeTimeOut;
  private resizeTimeOut;
  private resizeTimeOut2;

  public categoryType: string;
  gameJSON: any = {};
  giInfoInterval;
  manifest = [];
  public isPlayNow = true;
  public isMenuLoaded = false;
  public isFileDownloaded = false;
  public isServiceloaded = false;
  public isLoadGame = false;
  public isShowPlayFunFeature = false;
  public currentLanguage = '';
  public funGameNotAvailable = false;
  public displayLoadGameAnimation = false;
  pageName = PageConstant.INDEX;
  viewPage = PageConstant.INDEX;
  gameType;
  currentMenuName = PageConstant.FCG;
  currentTableType = FeatureConstant.PRIVATE;
  public fc21Array: Array<FC21Lobby> = [];
  public fcbArray: Array<FCBLobby> = [];
  isPlayerFavoriteCalled = false;
  popupref;
  betLimitPopupref;
  funGameNotAvailablePopUpref;
  alertRegisterPopupref;
  alertInsufficientPopupref;
  alertCommonPopupref;
  AlertLiveDealerNoSeatAvailablePopupref;
  menuListObject;
  menuListArrValue;
  isShowLobby = true;
  menuListObj1;
  menuListObj2;
  menuState1 = 'outstatedesktop';
  menuState2 = 'outstatedesktop';
  stateValFav = 'outstatedesktop';
  stateValBetLimit = 'outstatedesktop';
  mobileTableLimitGameName = 'LiveCasino';
  subMenuListArrValue: Menu = new Menu();
  menuListQueueArr = [];
  userBalance: any = 0;
  isFunPopUpScenarioEnable: boolean = false; //TODO: this variable to enable the fun popup option
  relaxConfigureSetting;
  funUserBalance = 0;
  fun_user_exist: boolean = false;
  usertypecode = 'ROBT';
  gameMinBetDetail = 0;
  gameStr = '';
  isChangePlstTOReal = false;
  inSufficientFund: boolean = false;
  isFullScreen: boolean = true;
  //isAutoFullScreenDone:boolean = false;
  isGameTypeRealOrFunPopUpEnable = false;
  lobbyLoadingInsideViasino = false;
  gameTypeRealOrFunOption: any;
  userCurrencyCode = 'USD';
  currentScrollPosition = 0;
  gameName = 'fc21';
  gameNameStr = 'fc21';
  seatAvailable = 5;
  gameInfo: any = {};
  totalAvailableSeat = '';
  public isLocalEnv = environment.envName === 'serve';
  public currentPageNumber = 0;
  params: any = {};
  liveCasinoLimitArr = [];
  liveDealerLimitArr = [];
  liveDealerBetLimitArr = [];
  liveDealerLimitgameDetailsArr = {};
  favoriteArray = [];
  favoriteBetLimitIdArray = [];
  settings = Settings;
  tempLanguage = LanguageConstant.ENGLISH;
  _subscriptionScale;
  isPortrait = false;
  menuObj = [{}];
  showSlideMenu = false;
  showSlideFav = false;
  showMenu = false;
  removeAllMenu = false;
  showSlidwTableLimit = false;
  showVIPPopup = false;
  public gameDetailsStateVal = 'outstate';
  receiveLiveDelaerQueuedUserEvent = undefined;
  isPopUpVisible = false;
  scaleR: any = {
    scale: 1,
    scaleX: 1,
    scaleY: 1,
    offsetLeft: 0,
    offsetTop: 0,
  };
  menuLoadCompleteSubscription;
  private currentRoomId: number | undefined;

  protected noLiveDealerSeats = true;
  //public isPendingGame = false;
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.removeMenu();
    this.showVIPPopup = false;
    if (this.gameDetailsStateVal === 'nostate') {
      this.onGameDetailsEmit('leavetoleft');
    }
  }

  @HostListener('window:message', ['$event'])
  onMessage(event) {
    if (event.data[0] && event.data[0].toLowerCase() == 'balance') {
      this.callGIInfo();
    }
    if (event.data[0] && event.data[0] == 'translatedLang') {
      let returnData: any = {};
      returnData.data = event.data[1];
      returnData.lang = 'languages';

      this.onSelectMenuOnList(returnData);
    }
  }
  constructor(
    public giInfoService: GIInfoService,
    public betLimitService: BetlimitService,
    public translate: TranslateService,
    public router: Router,
    public loadGameService: LoadGameService,
    public componentFactoryResolver: ComponentFactoryResolver,
    public viewContainerRef: ViewContainerRef,
    public errorPopupService: ErrorPopupService,
    public utilService: UtilService,
    public firebaseAnalyticsServices: FirebaseAnalyticsService,
    public userService: UserService
  ) {
    this.screenChangeHandler();
    document.addEventListener(
      'webkitfullscreenchange',
      this.screenChangeHandler
    );
    document.addEventListener('mozfullscreenchange', this.screenChangeHandler);
    document.addEventListener('fullscreenchange', this.screenChangeHandler);
    document.addEventListener('MSFullscreenChange', this.screenChangeHandler);
    this._subscriptionScale = utilService.scaleChange.subscribe((value) => {
      if (this.isPopUpVisible) {
        this.isPopUpVisible = false;
      }
      this.scaleR = value;
      this.resizeTimeOut = setTimeout(() => {
        this.checkAndSetIsPortrait();
        window.clearTimeout(this.resizeTimeOut);
      }, 300);
    });

    this.errorPopupService.showErrorPopUp().subscribe((ev) => {
      this.showErrorPopup(ev);
    });

    if (this.isLocalEnv) {
      this.languageChange(this.utilService.currentLanguage);
    }
    this.menuListObject = MenuListConstant.MENULIST;
    this.menuListArrValue = this.menuListObject.menu;
    this.menuState1 = 'outstatedesktop';
    this.menuState2 = 'outstatedesktop';
  }

  public updateParentScroll = () => {
    window.parent.postMessage(['navigate', true], '*');
  };

  checkAndSetIsPortrait = () => {
    let windowHeight =
      this.utilService.parentHeight != 0
        ? this.utilService.parentHeight
        : window.innerHeight;
    this.isPortrait = window.innerWidth < windowHeight;
  };

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    window.history.go(1);
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: FocusEvent): void {
    let currentPage = this.router.url.split('?')[0];
    if (currentPage == '/indexmobile' || currentPage == '/index') {
      return;
    }
    this.callGIInfo();
    if (this.giInfoInterval) {
      clearInterval(this.giInfoInterval);
    }
    this.giInfoInterval = window.setInterval(() => {
      this.callGIInfo();
      if (this.userService.user.first_name == 'UR-Viasino') {
        this.callPlayerFavoriteForTable();
      }
    }, 30000);
  }

  onResize = () => {
    let height = document.body.clientHeight;
    //console.log('Post Message: Cient Height: ' + height);
    window.parent.postMessage(['setHeight', height], '*');
    if (!this.utilService.isViewChangedByUser) {
      if (
        this.currentMenuName !== PageConstant.HISTORYDETAIL &&
        this.currentMenuName !== PageConstant.HISTORYSUMMARY &&
        this.currentMenuName !== PageConstant.HISTORYSUMMARYCONDENSED
      ) {
        if (window.innerWidth <= 1024) {
          this.onHeaderIconClick(PageConstant.MOBILE, true);
        } else {
          this.onHeaderIconClick(PageConstant.DESKTOP, true);
        }
      }
    }
    this.resizeTimeOut2 = setTimeout(() => {
      this.checkAndSetIsPortrait();
      if (this.isPortrait) {
        if (this.isEnableDecoderDesktopPopup) {
          this.isEnableDecoderMobilePopup = true;
          this.isEnableDecoderDesktopPopup = false;
        }
      } else if (this.isEnableDecoderMobilePopup) {
        this.isEnableDecoderDesktopPopup = true;
        this.isEnableDecoderMobilePopup = false;
      }
      window.clearTimeout(this.resizeTimeOut2);
    }, 300);
  };

  onGameDetailsEmit = (data) => {};

  subscribeMenuSprite() {
    if (this.menuLoadCompleteSubscription) {
      this.menuLoadCompleteSubscription.unsubscribe();
    }
    this.menuLoadCompleteSubscription = this.utilService
      .menuLoadComplete()
      .subscribe((event) => {
        this.isMenuLoaded = true;
        this.userService.user.isMenuLoaded = true;
        this.menuLoadCompleteSubscription.unsubscribe();
        this.onMenuLoaded(event);
        if (
          this.userService.user.isQueuedPlayer &&
          this.isFileDownloaded &&
          this.isMenuLoaded
        ) {
          this.betLimitService
            .makeQueuedUserRedirectToLD()
            .subscribe((limits) => {
              if (limits) {
                this.receiveLiveDealerQueuedUser(limits, true);
              }
            });
        }
      });
  }

  addResizeEventHandler() {
    window.addEventListener('resize', this.onResize);
  }

  removeResizeEventHandler() {
    window.removeEventListener('resize', this.onResize);
  }

  ngOnInit(): void {
    this.removeResizeEventHandler();
    this.addResizeEventHandler();
    clearInterval(this.giInfoInterval);
    let currentPage = this.router.url.split('?')[0];
    if (currentPage == '/indexmobile' || currentPage == '/index') {
      return;
    }
    console.log('CommonLayoutComponent ngOnInit');
    this.setSentryTags();
    this.giInfoInterval = window.setInterval(() => {
      this.callGIInfo();
      if (this.userService.user.first_name == 'UR-Viasino') {
        this.callPlayerFavoriteForTable();
      }
    }, 30000);
  }

  public initGIInfo() {
    this.subscribeMenuSprite();
    this.checkAndSetIsPortrait();
    this.utilService.showAppPreloader = false;
    let height = document.body.clientHeight;
    //console.log('Post Message: Cient Height: ' + height);
    this.updateParentScroll();
    window.parent.postMessage(['setHeight', height], '*');
    this.tempLanguage = this.utilService.currentLanguage;
    this.userService.user.isSessionActive = true;
    console.log('this.utilService.rngServerURL', this.utilService.rngServerURL);
    console.log('this.env', this.isLocalEnv);
    if (!this.isLocalEnv) {
      this.isLoadGame = false;
      this.userService.user.isGameStarted = false;
      this.isPlayerFavoriteCalled = false;
      this.giInfoService.getRNGServerURL().subscribe((response) => {
        console.log(response);
        this.utilService.rngServerURL = response.rngdomain;
        const gameIdFromUrl = getGameIdFromUrl();
        console.log('gameIdFromUrl', gameIdFromUrl);
        if (gameIdFromUrl) {
          this.loadGameFromUrl(gameIdFromUrl, response.rngdomain);
        }
      });
      this.callGIInfo(true);
      //this.getFunUserGameDetailInfo();
      //console.log('callGIInfo - first time');
      clearInterval(this.giInfoInterval);
      this.giInfoInterval = window.setInterval(() => {
        //console.log('GI INFO INTERVAL==========================');
        this.callGIInfo();
        if (this.userService.user.first_name == 'UR-Viasino') {
          this.callPlayerFavoriteForTable();
        }
      }, 30000);
    } else {
      if (this.utilService.rngServerURL) {
        const gameIdFromUrl = getGameIdFromUrl();
        if (gameIdFromUrl) {
          this.loadGameFromUrl(gameIdFromUrl, this.utilService.rngServerURL);
        }
      }
    }
  }

  callPlayerFavoriteForSettings(updateSettingsData = false) {
    const sendData: any = {};
    if (updateSettingsData) {
      sendData.userinfo = encodeURI(JSON.stringify(this.settings));
    }
    sendData.mode = 1;
    sendData.t = Date.now();
    this.giInfoService.callPlayerFavorite(sendData).subscribe((response) => {
      //console.log(response);
      //console.log(response.result);
      if (response.result) {
        this.updateSettings(response.result);
        if (!updateSettingsData) {
          this.callPlayerFavoriteForTable();
        }
      } else {
        this.callPlayerFavoriteForSettings(true);
      }
    });
  }

  updateSettings(settingsStr) {
    this.settings = JSON.parse(settingsStr);
    if (this.settings.language !== this.currentLanguage) {
      if (
        this.utilService.isUpdateLanguage &&
        this.utilService.currentLanguage != ''
      ) {
        this.settings.language = this.utilService.currentLanguage;
        this.callPlayerFavoriteForSettings(true);
        this.utilService.isUpdateLanguage = false;
      } else {
        this.languageChange(
          this.settings.language
            ? this.settings.language
            : LanguageConstant.ENGLISH
        );
      }
    }
  }

  getFunUserGameDetailInfo() {
    if (!this.isLocalEnv) {
      this.giInfoService.getFunUserGameDetail().subscribe((response) => {
        //console.log('getFunUserGameDetailInfo - getFunUserGameDetail--nrs',response);
        /*response * betlimits: null * funuserbalance: 0 * funuserexist: true * funusergamepending: false * statuscode: 0 * statusmessage: "Success" * */
        if (response.statusmessage === 'Success') {
          this.userService.user.funUserBalance = response.funuserbalance;
          this.funUserBalance = response.funuserbalance;
          if (
            this.userService.user.usertypecode == 'PLST' &&
            response.funuserbalance == 0 &&
            !response.funusergamepending &&
            response.funuserexist
          ) {
            if (this.isFileDownloaded && !this.isLoadGame) {
              // this.PlayForFunNotAvailableAlert(); // Commented based on David's Skype message on ticket# 21 or Nothing -#199, "WHEN IN THE GAME send the alert not every single time i log into the lobby"
              this.betLimitService
                .playForFunCheckLogin('playforreal')
                .subscribe((response) => {
                  this.userService.user.initialusertype = 'PLAY';
                  this.callGIInfo();
                });
            }
          }
          if (
            response.funuserbalance < this.userService.user.gameminbet &&
            response.funuserexist
          ) {
            if (
              response.funuserbalance == 0 &&
              response.funuserexist &&
              !response.funusergamepending
            ) {
              //console.log('dont have SufficientFund to play fun')
              this.inSufficientFund = true;
            }
          }
        }
      });
    }
  }
  public callGIInfo = (firsttime = false) => {
    if (this.isLocalEnv) return;

    //console.log('============Call GI Info================');
    if (this.pageName == PageConstant.REPORTS) {
      return;
    }

    this.giInfoService.callGIInfo().subscribe({
      next: (response) => {
        //console.log(response);
        //console.log(response.respond);
        if (response.error) {
          // this.showErrorPopup({
          //   httpCode: response.error.status,
          // });
          clearInterval(this.giInfoInterval);
          return;
        }

        if (response.respond === true) {
          if (response.flylogin) {
            const homeurl = this.utilService.getHomeUrlFromStorage();
            if (!homeurl || homeurl === 'null') {
              const newMenuList = this.menuListArrValue.menuListItems.filter(
                (menu) => menu.menuListName !== 'logout'
              );
              this.menuListArrValue.menuListItems = newMenuList;
            }
          }

          this.giInfoService.timeinfo().subscribe((response) => {
            this.utilService.currentYear = response.time;
            //console.log('this.utilService.currentYear');
            //console.log(this.utilService.currentYear);
          });

          this.callGIInfoDataUpdate(response);

          if (this.userService.user.usertypecode == 'PLST') {
            this.isFunPopUpScenarioEnable = true;
            this.isShowPlayFunFeature = true;
            this.getFunUserGameDetailInfo();
          } else {
            this.isFunPopUpScenarioEnable = false;
            this.isShowPlayFunFeature = false;
          }

          if (
            this.userService.user.initialusertype == undefined &&
            this.userService.user.usertypecode
          ) {
            this.userService.user.initialusertype =
              this.userService.user.usertypecode;
            //console.log("this.userService.user.initialusertype",this.userService.user.initialusertype);
            if (this.userService.user.appusertype != undefined) {
              if (
                this.userService.user.appusertype !=
                this.userService.user.usertypecode
              ) {
                this.userService.user.initialusertype =
                  this.userService.user.appusertype;
                let userTypeId = '';
                if (
                  this.userService.user.appusertype == 'PLAY' ||
                  this.userService.user.appusertype == 'ROBT'
                ) {
                  userTypeId = 'playforreal';
                } else {
                  userTypeId = 'playforfun';
                }
                this.betLimitService
                  .playForFunCheckLogin(userTypeId)
                  .subscribe((response) => {
                    this.callGIInfo();
                  });
              } else {
                this.checkAndCallPlayerFavorite();
              }
            } else {
              this.checkAndCallPlayerFavorite();
            }
          } else {
            this.checkAndCallPlayerFavorite();
          }
        } else {
          console.log('isFlylogin :::: ' + this.userService.user.isFlyLogin);
          if (this.userService.user.isFlyLogin) {
            //console.log('showErrorPopup Call From Common Layout');
            //console.log(this.userService.user.reloadURL);
            if (this.userService.user.reloadURL != undefined) {
              window.open(this.userService.user.reloadURL, '_self');
            } else {
              this.showErrorPopup();
            }
          } else {
            this.loadIndexPage();
          }
        }
      },
      error: (error) => {
        console.error('Error occurred while calling GI Info:', error);
        if (error.status === 401) {
          this.captureErrorCode(
            'gameuserinfo.jsp: 401 Unauthorized. User session not expired.'
          );
          clearInterval(this.giInfoInterval);
        }
      },
    });
  };

  captureErrorCode(message: string) {
    // capureErrorCode is used to capture error codes with sentry
    // enrich the error message with additional information using Sentry setTags
    // get information from the session storage
    // {"x-fcg-last-activity":"Z0FBQUFBQm9OSmhFVHdWbzJWak4wSEpSb1p5SmlzNlVKRi12Qk9STk9JREZta1YyS2hkNy1TNVJFNzRKUENTVnFOc3FfUzN2SXFMQzZBaE9tcGVQbUMxVWhRanpaZWk5OEE9PQ==","x-fcg-last-activity-iso":"2025-05-26T16:35:16+00:00","__darkreader__wasEnabledForHost":"false","x-fcg-access-token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoidGVzdC05ZjNiYWE4NzIzNSIsImNhc2lub19pZCI6ImZjYzEyMzQ1Njc4OTBhYmMiLCJmdW51c2VyX2lkIjoidGVzdC05ZjZhMzA0MzE2MyIsInByYWN0aWNlX21vZGUiOmZhbHNlLCJleHAiOjE3NDgzNjM2OTYuMjk1MjMsInRva2VuX3R5cGUiOiJhY2Nlc3MifQ.1D--Xcut8Ti5x7dWGK2uctXk-ZsIl7i6UlnKRYE8THo","x-fcg-last-activity-epoch":"1748277316","sentryReplaySession":"{\"id\":\"52c2f7167bca4f73a8f93782b0c6174f\",\"started\":1748277376837,\"lastActivity\":1748277321961,\"segmentId\":0,\"sampled\":\"buffer\"}"}
    // decode the x-fcg-access-token get the user_id, casino_id, and funuser_id
    // make the epoch time human readable
    // make the last activity time human readable
    const currentEpoch = sessionStorage.getItem('x-fcg-last-activity-epoch');

    // is epoch older than 15 minutes
    const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;
    const epochTimeMs = currentEpoch ? parseInt(currentEpoch, 10) * 1000 : null; // Convert to milliseconds
    const isSessionExpired =
      epochTimeMs && !isNaN(epochTimeMs)
        ? Date.now() - epochTimeMs > FIFTEEN_MINUTES_MS
        : false;

    if (isSessionExpired) {
      console.log('Session expired, not capturing error message');
      // If the session is expired, we don't want to capture the error
      // because it is not an error but a normal case of session expiration
      return;
    }

    Sentry.captureMessage(message, {
      level: 'fatal',
    });
  }

  /**
   * method receiveLiveDealerQueuedUser
   * @param queueduser
   * @param status
   * @returns
   */
  receiveLiveDealerQueuedUser = (queueduser, status) => {
    //console.log('receiveLiveDealerQueuedUser',queueduser,status);

    //queueduser = {"fcg21nv8sv7rk1jk":[{"betlimitid":1,"min":5,"max":50,"chips":"0.25,0.50,1,5,25,100","defaultchip":3},{"betlimitid":2,"min":10,"max":100,"chips":"0.25,0.50,1,5,25,100","defaultchip":2},{"betlimitid":3,"min":25,"max":250,"chips":"0.25,0.50,1,5,25,100","defaultchip":3},{"betlimitid":4,"min":50,"max":500,"chips":"0.50,1,5,25,100,500","defaultchip":3},{"betlimitid":5,"min":100,"max":1000,"chips":"1,5,25,100,500,1000","defaultchip":2}]}
    /*console.log('this.utilService.viewMode this.isGameOver',this.isGameOver,this.utilService.viewMode,queueduser);
    //console.log('receiveLiveDealerQueuedUser======================','QueuedUser',queueduser,
                 'QueuedUser.server.betLimits',queueduser,
                  Object.keys(queueduser),this.receiveLiveDelaerQueuedUserEvent); */
    if (this.receiveLiveDelaerQueuedUserEvent != undefined) return;
    if (status) {
      this.isPopUpVisible = true;
    }
    let tableid_QueuedUser = Object.keys(queueduser);
    let tableLimit_QueuedUser = [];
    tableLimit_QueuedUser = [...queueduser[tableid_QueuedUser[0]]];
    let messageObj: any = {};
    messageObj.tableid_QueuedUser = tableid_QueuedUser;
    messageObj.betLimits = [...tableLimit_QueuedUser];
    messageObj.lang = this.currentLanguage;
    messageObj.scaleR = this.scaleR;
    (messageObj.userCurrency = this.userCurrencyCode),
      (messageObj.isPopUpVisible = this.isPopUpVisible);
    messageObj.isportrait = this.isPortrait ? true : false;
    messageObj.isMenuLoaded = this.userService.user.isMenuLoaded;
    //console.log('messageObj--------------->receiveLiveDealerQueuedUser',messageObj);/
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      BetLimitPopupComponent
    );
    this.receiveLiveDelaerQueuedUserEvent =
      this.viewContainerRef.createComponent(factory);
    let data = $.extend(messageObj);
    this.receiveLiveDelaerQueuedUserEvent.instance.data = data;
    this.receiveLiveDelaerQueuedUserEvent.instance.redirectEmit.subscribe(
      (data) => {
        //console.log('this.receiveLiveDelaerQueuedUserEvent.instance.redirectEmit.subscribe-------data',data);
        /* {"optionValue": 2,"tableid_QueuedUser": "fcg21nv8sv7rk1jk"} */
        this.receiveLiveDelaerQueuedUserEvent.destroy();
        this.receiveLiveDelaerQueuedUserEvent = undefined;
        if (data.optionValue == 'backtogame') {
          this.betLimitService.makeRemoveFromQueue().subscribe((data) => {
            //console.log('this.betLimitService.makeRemoveFromQueu',data);
          });
        } else {
          let gameDetails: any = {};
          gameDetails.tabletype = data.tableid_QueuedUser;
          gameDetails.gameType = 'livedealer';
          gameDetails.tableid = data.tableid_QueuedUser;
          /* gameDetails-======>{"tabletype": "fcg21nv8sv7rk1jk","gameType": "livedealer","tableid": "fcg21nv8sv7rk1jk" } */
          this.checkLiveDealerSeatsAvailability(
            'fc21',
            'livedealer',
            data.optionValue,
            '7',
            '0',
            gameDetails
          );
        }

        this.isPopUpVisible = false;
      }
    );
  };

  /**
   * ##QuickStartAlertTrigger
   * @param popUpTo
   */
  QuickStartAlertTrigger(popUpTo = 'cardShuffling') {
    if (this.AlertLiveDealerNoSeatAvailablePopupref) {
      this.AlertLiveDealerNoSeatAvailablePopupref.destroy();
      this.AlertLiveDealerNoSeatAvailablePopupref = undefined;
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      alertLiveDealerNoSeatAvailableComponent
    );
    this.AlertLiveDealerNoSeatAvailablePopupref =
      this.viewContainerRef.createComponent(factory);
    this.AlertLiveDealerNoSeatAvailablePopupref.instance['alertData'] = {
      ref: this.AlertLiveDealerNoSeatAvailablePopupref,
      userCurrency: this.userCurrencyCode,
      currentLanguage: this.currentLanguage,
      LDSeatsObj: undefined,
      popUpTo: popUpTo,
    };
    this.AlertLiveDealerNoSeatAvailablePopupref.instance['eventEmit'].subscribe(
      (data) => {
        //console.log('AlertInsufficientPopupClick', data);
        if (data.status == 'close') {
          this.AlertLiveDealerNoSeatAvailablePopupref.destroy();
          this.AlertLiveDealerNoSeatAvailablePopupref = undefined;
        } else if (data.status == 'redirect') {
          if (Settings.appSettings.iscardShufflingEnable) {
            this.AlertLiveDealerNoSeatAvailablePopupref.destroy();
            this.AlertLiveDealerNoSeatAvailablePopupref = undefined;
            this.loadGameService.openVideo(
              this.currentLanguage,
              +Settings.appSettings.shufflevideolimitinmins
            );
          } else {
            this.AlertLiveDealerNoSeatAvailablePopupref.destroy();
            this.AlertLiveDealerNoSeatAvailablePopupref = undefined;
            this.showCommingSoonPopup();
          }
        }
      }
    );
  }
  checkAndCallPlayerFavorite = () => {
    if (!this.isPlayerFavoriteCalled) {
      this.callPlayerFavoriteForSettings();
      this.isPlayerFavoriteCalled = true;
    }
  };

  /* alertLiveDealerNoSeatAvailableComponent */
  AlertLiveDealerNoSeatAvailableTrigger(LDSeatsObj) {
    if (this.AlertLiveDealerNoSeatAvailablePopupref) {
      this.AlertLiveDealerNoSeatAvailablePopupref.destroy();
      this.AlertLiveDealerNoSeatAvailablePopupref = undefined;
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      alertLiveDealerNoSeatAvailableComponent
    );
    this.AlertLiveDealerNoSeatAvailablePopupref =
      this.viewContainerRef.createComponent(factory);
    this.AlertLiveDealerNoSeatAvailablePopupref.instance['alertData'] = {
      ref: this.AlertLiveDealerNoSeatAvailablePopupref,
      userCurrency: this.userCurrencyCode,
      currentLanguage: this.currentLanguage,
      LDSeatsObj: LDSeatsObj,
      popUpTo: 'LiveDealerNoSeat',
    };
    this.AlertLiveDealerNoSeatAvailablePopupref.instance['eventEmit'].subscribe(
      (data) => {
        //console.log('AlertInsufficientPopupClick', data);
        this.isPlayNow = true;
        if (data.status == 'close') {
          this.AlertLiveDealerNoSeatAvailablePopupref.destroy();
          this.AlertLiveDealerNoSeatAvailablePopupref = undefined;
          if (this.isChangePlstTOReal) {
            this.betLimitService
              .playForFunCheckLogin('playforfun')
              .subscribe((response) => {
                //console.log('playForFunCheckLogin---->session token changed', response);
                this.isChangePlstTOReal = false;
              });
          }
          if (LDSeatsObj.closeBehaviour === 'lobbyRedirect') {
            if (this.utilService.isDesktopView) {
              this.pageNavigate(PageConstant.FCG);
            } else {
              this.pageNavigate(PageConstant.FCGMOBILE);
            }
          }
        } else if (data.status == 'redirect') {
          this.betLimitService
            .addQueuedPlayersInfo()
            .subscribe((queuedplayer) => {
              //console.log("this.betLimitService.addQueuedPlayersInfo", queuedplayer);
              //this.navigateToSameTablePage('livecasino', 5);
              this.AlertLiveDealerNoSeatAvailablePopupref.destroy();
              this.AlertLiveDealerNoSeatAvailablePopupref = undefined;
              ///this.betLimitPopupref.destroy();
              //this.betLimitPopupref = undefined;
              this.showBetLimitPopup('LiveCasino');
            });
        }
      }
    );
  }

  onDropDownIconClick = (seat, gameType) => {
    //console.log("seat, gameType",seat, gameType)
    //console.log('seatAvaika', seat);
    //console.log('gameTypeAvaika', gameType);
    const params = {
      type: gameType,
      seat: seat,
    };
    this.pageNavigate(PageConstant.FC21TABLESMOBILE, params);
  };
  navigateToSameTablePage(gameType, seat) {
    //console.log('navigateToSameTablePage',gameType, seat);
    this.isFileDownloaded = false;
    this.isServiceloaded = false;
    this.isPlayerFavoriteCalled = false;
    this.currentLanguage = 'desc';
    let params = {
      type: gameType,
      seat: seat,
    };
    this.loadGameService.addItem(
      '3',
      FeatureConstant[gameType.toUpperCase() + '_LANG']
    );
    // (<HTMLTextAreaElement>document.getElementById('loggerr')).value += '\n this.utilService.isDesktopView' + this.utilService.isDesktopView;
    if (this.utilService.isDesktopView) {
      this.pageNavigate(PageConstant.FC21TABLES, params);
    } else {
      this.pageNavigate(PageConstant.FC21TABLESMOBILE, params);
    }
  }
  commonAlertPopupTrigger() {
    if (this.alertCommonPopupref) {
      this.alertCommonPopupref.destroy();
      this.alertCommonPopupref = undefined;
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      alertInsufficientPopupMobileComponent
    );
    this.alertCommonPopupref = this.viewContainerRef.createComponent(factory);
    this.alertCommonPopupref.instance['alertData'] = {
      ref: this.alertCommonPopupref,
      userCurrency: this.userCurrencyCode,
      currentLanguage: this.currentLanguage,
      errorStatusString: 'LANG01103',
      errorStatusOnlyText: true,
    };
    this.alertCommonPopupref.instance['eventEmit'].subscribe((data) => {
      //console.log('AlertInsufficientPopupClick', data);
      if (data == 'close') {
        this.alertCommonPopupref.destroy();
        this.alertCommonPopupref = undefined;
      }
    });
  }
  AlertInsufficientPopupTrigger(type) {
    //console.log(type);

    //console.log('this.userBalance.-------', this.userBalance);
    //console.log('this.funUserBalance.-------', this.funUserBalance);
    //console.log('this.userService.user.gameminbet.-------', this.userService.user.gameminbet);

    if (this.alertInsufficientPopupref) {
      this.alertInsufficientPopupref.destroy();
      this.alertInsufficientPopupref = undefined;
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      alertInsufficientPopupMobileComponent
    );
    this.alertInsufficientPopupref =
      this.viewContainerRef.createComponent(factory);
    this.alertInsufficientPopupref.instance['alertData'] = {
      ref: this.alertInsufficientPopupref,
      userCurrency: this.userCurrencyCode,
      currentLanguage: this.currentLanguage,
      errorStatusString: 'LANG00029',
      errorStatusOnlyText: false,
    };
    this.alertInsufficientPopupref.instance['eventEmit'].subscribe((data) => {
      if (data == 'close') {
        //console.log('window.parent.postMessage(["opendeposit", true ], "*");');
        window.parent.postMessage(['opendeposit', true], '*');
        this.alertInsufficientPopupref.destroy();
        this.alertInsufficientPopupref = undefined;
      }
    });
  }

  AlertRegisterPopupTrigger() {
    this.updateParentScroll();
    if (this.alertRegisterPopupref) {
      this.alertRegisterPopupref.destroy();
      this.alertRegisterPopupref = undefined;
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      AlertPlayerRegisterPopupMobileComponent
    );
    this.alertRegisterPopupref = this.viewContainerRef.createComponent(factory);
    this.alertRegisterPopupref.instance['alertData'] = {
      ref: this.alertRegisterPopupref,
      AlertPlayerRegisterPopupEnable: true,
      userCurrency: this.userCurrencyCode,
      currentLanguage: this.currentLanguage,
    };
    this.alertRegisterPopupref.instance['eventEmit'].subscribe((data) => {
      //console.log('RegisterPopupClick window.parent.postMessage(["openlogin", true ], "*");', data);
      window.parent.postMessage(['openlogin', true], '*');
      this.alertRegisterPopupref.destroy();
      this.alertRegisterPopupref = undefined;
    });
  }

  PlayForFunNotAvailableAlert() {
    //this.betLimitPopupref.destroy();
    //this.betLimitPopupref = undefined;
    if (this.funGameNotAvailablePopUpref) {
      this.funGameNotAvailablePopUpref.destroy();
      this.funGameNotAvailablePopUpref = undefined;
    }
    //console.log('funGameNotAvailablePopUpref---->this is for play for fun not available');
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      PlayForFunAlertLayoutMobileComponent
    );
    this.funGameNotAvailablePopUpref =
      this.viewContainerRef.createComponent(factory);
    this.funGameNotAvailablePopUpref.instance['alertData'] = {
      ref: this.funGameNotAvailablePopUpref,
      funGameNotAvailable: true, //this.funGameNotAvailable,
      userCurrency: this.userCurrencyCode,
      currentLanguage: this.currentLanguage,
    };
    this.funGameNotAvailablePopUpref.instance['eventEmit'].subscribe((data) => {
      this.funGameNotAvailablePopUpref.destroy();
      this.funGameNotAvailablePopUpref = undefined;
      this.callGIInfo();
    });
  }
  public loadIndexPage() {
    //console.log(window.location);
    //console.log('loadIndexPage');
    //console.log(this.userService.user.isFlyLogin);
    //console.log(this.utilService.isLoadedFromGame);
    //console.log(this.userService.user.reloadURL);
    this.loadGameService.logout();
    if (this.giInfoInterval) {
      clearInterval(this.giInfoInterval);
    }

    if (
      this.pageName == PageConstant.GAME ||
      this.pageName == PageConstant.REPORTS
    ) {
      window.close();
    } else {
      if (
        this.userService.user.reloadURL != undefined &&
        this.userService.user.reloadURL != ''
      ) {
        window.open(this.userService.user.reloadURL, '_self');
      } else {
        if (this.userService.user.isFlyLogin) {
          window.close();
        } else {
          window.location.replace('/index.jsp');
        }
      }
    }
  }

  public languageChange = (currentLang) => {
    //console.log("languageChange RRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR", currentLang);
    this.menuListObj1 = undefined;
    this.menuListObj2 = undefined;
    this.tempLanguage = currentLang;
    this.utilService.currentLanguage = this.tempLanguage;
    this.subscribeMenuSprite();
    this.setLanguageTranslatForManifest(currentLang);
    this.isFileDownloaded = false;
    this.isServiceloaded = false;
    this.translate.use(currentLang); //todo later have to check // sethupahty
    /* window.parent.postMessage(["translatedLang", currentLang ], "*"); */
  };

  /**
   * this method used to get the current language
   * @ param currentLang
   */
  setLanguageTranslatForManifest(currentLang) {}

  onMenuLoaded(event) {
    this.utilService.loadMiscManifest();
  }

  onDownloadComplete(event) {
    //console.log("this.userService.user.isGameStarted",this.userService.user.isGameStarted);
    if (this.userService.user.isGameStarted) {
      return;
    }
    this.manifest = [];
    this.isMenuLoaded = false;
    this.userService.user.isMenuLoaded = false;
    this.utilService.loadMenuManifest();
    //console.log('On Download complete');
    this.menuState1 = 'outstatedesktop';
    this.menuState2 = 'outstatedesktop';
    this.showMenu = false;
    this.showSlideMenu = false;
    this.isFileDownloaded = true;
    this.currentLanguage = this.tempLanguage;
    this.translate.use(this.currentLanguage);
    if (this.pageName != PageConstant.REPORTS) {
      this.loadBetLimit();
      this.getFunUserGameDetailInfo();
    }
    this.initDetailHistory();
  }

  initDetailHistory() {}

  updateTable() {}

  updateLiveDealerTable = () => {
    this.betLimitService.getLiveDealerBetLimit().subscribe((limits) => {
      //console.log("this.betLimitService.getLiveDealerBetLimit this.betLimitService.getLiveDealerBetLimit",limits);
      this.betLimitService.fc21JSON.livedealer.limits = [];
      this.betLimitService.fc21JSON.livedealer.limits = [...limits];
      this.liveDealerLimitArr = this.betLimitService.fc21JSON.livedealer.limits;
      this.updateTable();
    });
  };
  loadBetLimit() {
    if (!this.isLocalEnv) {
      this.betLimitService.getBetLimit().subscribe((response) => {
        if (response.status.toLowerCase() === 'success') {
          //console.log("response betLimitService.getBetLimit",response);
          this.gameMinBetDetail = parseFloat(
            response.betlimit.fcg21ornothing.rng.multiplayer.fcg21ornothingrtp
              .minbet
          );
          this.userService.user.gameminbet = parseFloat(
            response.betlimit.fcg21ornothing.rng.multiplayer.fcg21ornothingrtp
              .minbet
          );
          //console.log("this.gameMinBetDetail",this.gameMinBetDetail)
          this.fc21Array = this.betLimitService.setFC21Data(
            this.utilService.isDesktopView
          );
          this.fcbArray = this.betLimitService.setFCBData();
          let gameArr = [
            ...this.betLimitService.fc21JSON[this.currentTableType].limits,
          ];
          if (this.pageName === PageConstant.FC21TABLES) {
            gameArr = [
              ...this.betLimitService.fc21JSON[this.currentTableType].limits,
            ];
          } else if (this.pageName === PageConstant.FCBTABLES) {
            //console.log(this.betLimitService.fcbJSON);
            gameArr = [
              ...this.betLimitService.fcbJSON[this.currentTableType].limits,
            ];
          }
          this.gameJSON =
            this.betLimitService.fc21JSON[FeatureConstant.LIVECASINO];
          //console.log('this.betLimitService.fc21JSON.livedealer.limits', this.betLimitService.fc21JSON.livedealer.limits);
          let gameArrLC = [...this.betLimitService.fc21JSON.livecasino.limits];
          this.liveDealerLimitArr =
            this.betLimitService.fc21JSON.livedealer.limits;
          this.liveDealerBetLimitArr =
            this.betLimitService.fc21JSON.livedealer.limits;
          this.liveCasinoLimitArr = gameArrLC.slice(0, gameArrLC.length - 1);
          //console.log('this.liveCasinoLimitArr',this.liveCasinoLimitArr,'gameArr',gameArr,'gameArrLC',gameArrLC,'liveDealerLimitArr',this.liveDealerLimitArr);
          if (this.pageName === PageConstant.FCBTABLES) {
            this.updateTable();
          } else if (this.pageName === PageConstant.FC21TABLES) {
            if (this.gameType === FeatureConstant.LIVEDEALER) {
              //console.log('loadBetLimit-------->this.pageName', this.pageName);
              //console.log('loadBetLimit-------->this.gameType', this.gameType);
              this.updateLiveDealerTable();
            } else {
              this.updateTable();
            }
          } else {
            if (this.viewPage != PageConstant.HISTORY) {
              this.updateServiceLoadComplete('loadBetLimit');
            }
          }
          document.body.style.overflow = 'auto';
        } else {
          // show error pop-up
        }
      });
    } else {
      this.betLimitService.setBetLimitForLocalEnv();
      this.fc21Array = this.betLimitService.setFC21Data(
        this.utilService.isDesktopView
      );
      this.fcbArray = this.betLimitService.setFCBData();
      let gameArr = [
        ...this.betLimitService.fc21JSON[this.currentTableType].limits,
      ];
      if (this.pageName === PageConstant.FC21TABLES) {
        gameArr = [
          ...this.betLimitService.fc21JSON[this.currentTableType].limits,
        ];
      } else if (this.pageName === PageConstant.FCBTABLES) {
        //console.log(this.betLimitService.fcbJSON);
        gameArr = [
          ...this.betLimitService.fcbJSON[this.currentTableType].limits,
        ];
      }
      let gameArrLC = [];

      gameArrLC = [...this.betLimitService.fc21JSON['livecasino'].limits];
      this.liveDealerLimitArr = this.betLimitService.fc21JSON.livedealer.limits;
      this.liveCasinoLimitArr = gameArrLC.slice(0, gameArrLC.length - 1);

      if (
        this.pageName === PageConstant.FC21TABLES ||
        this.pageName === PageConstant.FCBTABLES
      ) {
        this.updateTable();
        //console.log('loadBetLimit-------->this.pageName-local', this.pageName);
        //console.log('loadBetLimit-------->this.gameType-local', this.gameType);
      } else {
        this.updateServiceLoadComplete('loadBetLimit -- env false');
      }
      document.body.style.overflow = 'auto';
    }
  }

  askGameTypeRealOrFun(
    vale,
    gameName,
    gameFeatureName,
    betLimitId,
    seatAvailable,
    newtable
  ) {
    //console.log("askGameTypeRealOrFun vale,gameName, gameFeatureName, betLimitId, seatAvailable, newtable",vale,gameName, gameFeatureName, betLimitId, seatAvailable, newtable)
    this.isGameTypeRealOrFunPopUpEnable = vale;
    if (!this.isGameTypeRealOrFunPopUpEnable) return;
    this.gameTypeRealOrFunOption = {
      inSufficientFund: this.inSufficientFund,
      isGameTypeRealOrFunPopUpEnable: this.isGameTypeRealOrFunPopUpEnable,
      gameName: gameName,
      gameFeatureName: gameFeatureName,
      betLimitId: betLimitId,
      tableIndex: betLimitId > 5 ? betLimitId - 6 : betLimitId - 1,
      seatAvailable: seatAvailable,
      newtable: newtable,
    };
  }

  extractRoomId(inputString) {
    // Regular expression to find 'roomId-' followed by one or more digits
    const regex = /roomId-(\d+)/;

    // Use the regex to search the input string
    const match = inputString.match(regex);

    // Check if any match was found
    if (match && match[1]) {
      // match[1] contains the first captured group which are the digits following 'roomId-'
      return parseInt(match[1], 10); // convert the matched number to an integer
    } else {
      // If no match was found, handle according to requirements, for example returning undefined or an error
      return undefined;
    }
  }

  onIconClick = (
    iconName,
    forceLoadGame = false,
    gameType = undefined,
    gameDetails = undefined
  ) => {
    // (<HTMLTextAreaElement>document.getElementById('loggerr')).value += '\n onIconClick' + iconName;
    //console.log('OnIconClick');/* example private_fc21_false_1_3 *//* example livecasino_fc21_false_2_5_0 */,'livedealer',gameDetails
    //console.log("OnIconClick--->", iconName, forceLoadGame);
    const isCommingSoon: boolean =
      iconName.split('_')[2] === 'true' ? true : false;
    //console.log("isCommingSoon",isCommingSoon);

    if (forceLoadGame) {
      this.loadGameOrNavigatepage(iconName);
    }
    if (gameType && gameDetails) {
      //livedealer_fc21_true_1_7_0_true  livedealer_fc21_true_1_7_0_true
      iconName = iconName + '_directGame_' + gameDetails.tableid;
      this.showCommingSoonPopup(iconName);
      return;
    }
    if (isCommingSoon) {
      this.showCommingSoonPopup(iconName);
      return;
    }
    this.loadGameOrNavigatepage(iconName);
  };

  loadGameOrNavigatepage(iconName, forceLoadGame = false) {
    // (<HTMLTextAreaElement>document.getElementById('loggerr')).value += '\n loadGameOrNavigatepage' + iconName;
    //console.log('loadGameOrNavigatepage',iconName, forceLoadGame);//livedealer_fc21_true_1_7_0_true
    let gameFeatureName: string = iconName.split('_')[0];
    const gameName: string = iconName.split('_')[1];
    let isCommingSoon: boolean =
      iconName.split('_')[2] === 'true' ? true : false;
    const betLimitId: number = iconName.split('_')[3];
    const seatAvailable = iconName.split('_')[4] ? iconName.split('_')[4] : 1;
    let newtable: number = iconName.split('_')[5]
      ? parseInt(iconName.split('_')[5], 2)
      : 0;
    let directGame: string = iconName.split('_')[7]
      ? iconName.split('_')[7]
      : null;
    let tableid: string = iconName.split('_')[8]
      ? iconName.split('_')[8]
      : null;

    const roomId = this.extractRoomId(iconName);
    this.currentRoomId = roomId;

    //console.log("gameFeatureName-----", gameFeatureName);
    //console.log("gameName-----", gameName);
    //console.log("isCommingSoon-----", isCommingSoon);
    //console.log("this-----.pageName", this.pageName);
    //console.log("betLimitId-----", betLimitId);
    //console.log("seatAvailable-----", seatAvailable);
    //console.log("newtable-----", newtable);
    //console.log("this.usertypecode-----", this.usertypecode);
    //console.log("forceLoadGame-----", forceLoadGame);
    //console.log("this.usertypecode",this.usertypecode);
    //console.log('this.betLimitPopupref',this.betLimitPopupref);
    if (directGame === 'directGame') {
      //livedealer_fc21_true_1_7_0_true_directGame_fcg21nv8sv7rk1jk
      let gameDetails: any = {};
      gameDetails.tableid = tableid;
      this.showLiveDealerBetLimitPopup(gameFeatureName, gameDetails);
      return;
    }
    if (
      gameFeatureName === GameTypeConstant.LIVEDEALER &&
      gameName === GameConstant.FC21
    ) {
      this.navigateToSameTablePage('livedealer', 7);
      return;
    }
    this.seatAvailable = seatAvailable;
    if (forceLoadGame) {
      if (this.usertypecode == 'PLST') {
        this.checkBeforeLoadGame(
          gameName,
          gameFeatureName,
          betLimitId,
          seatAvailable,
          newtable,
          'playforreal',
          this.userBalance
        );
      } else {
        this.checkBeforeLoadGame(
          gameName,
          gameFeatureName,
          betLimitId,
          seatAvailable,
          newtable,
          undefined,
          this.userBalance
        );
      }
      return;
    }
    if (gameName === GameConstant.FC21) {
      if (
        this.pageName === PageConstant.FCG ||
        this.pageName === PageConstant.FC21
      ) {
        //console.log('gameFeatureName');
        //console.log(gameFeatureName);
        this.navigateToSameTablePage(gameFeatureName, seatAvailable);
      } else if (this.pageName === PageConstant.FC21TABLES) {
        if (
          this.isFunPopUpScenarioEnable &&
          this.betLimitPopupref == undefined &&
          gameFeatureName != GameTypeConstant.LIVEDEALER
        ) {
          this.giInfoService.getFunUserGameDetail().subscribe((response) => {
            //console.log('getFunUserGameDetail--nrs',response);
            //console.log('selcted tabel details--nrs',gameName, gameFeatureName, betLimitId, seatAvailable, newtable);
            if (response.statusmessage === 'Success') {
              this.userService.user.funUserBalance = response.funuserbalance;
              this.funUserBalance = response.funuserbalance;
              if (
                response.funuserbalance < this.userService.user.gameminbet &&
                response.funuserexist
              ) {
                if (
                  response.funuserbalance == 0 &&
                  response.funuserexist &&
                  !response.funusergamepending
                ) {
                  //console.log('dont have SufficientFund to play fun')
                  this.inSufficientFund = true;
                  //console.log('response.funuserbalance == 0 && response.funuserexist && !response.funusergamepending');
                  //console.log('dont have SufficientFund to play fun');
                  this.askGameTypeRealOrFun(
                    true,
                    gameName,
                    gameFeatureName,
                    betLimitId,
                    seatAvailable,
                    newtable
                  );
                  return;
                } else if (
                  response.betlimits.fcg21ornothing.rng.privatetable.limits[
                    seatAvailable
                  ] == undefined
                ) {
                  this.inSufficientFund = true;
                  //console.log('response.betlimits.fcg21ornothing.rng.privatetable.limits[seatAvailable] == undefined------>no pending game for selcted hand');
                  //console.log('no pending game for selcted hand');
                  //console.log('dont have SufficientFund to play fun');
                  this.askGameTypeRealOrFun(
                    true,
                    gameName,
                    gameFeatureName,
                    betLimitId,
                    seatAvailable,
                    newtable
                  );
                  return;
                } else if (
                  response.betlimits.fcg21ornothing.rng.privatetable.limits[
                    seatAvailable
                  ]['6'].isgamepending
                ) {
                  this.inSufficientFund = false;
                  //console.log("response.betlimits.fcg21ornothing.rng.privatetable.limits[seatAvailable]['6'].isgamepending", response.betlimits.fcg21ornothing.rng.privatetable.limits[seatAvailable]['6'].isgamepending);
                  //console.log('have SufficientFund to play fun')
                } else {
                  this.inSufficientFund = true;
                  //console.log("response.betlimits.fcg21ornothing.rng.privatetable.limits[seatAvailable]['6'].isgamepending", response.betlimits.fcg21ornothing.rng.privatetable.limits[seatAvailable]['6'].isgamepending);
                  //console.log('dont have SufficientFund to play fun')
                }
              }
              this.askGameTypeRealOrFun(
                true,
                gameName,
                gameFeatureName,
                betLimitId,
                seatAvailable,
                newtable
              );
              return;
            }
          });

          return;
        }
        //console.log('this.betLimitPopupref',this.betLimitPopupref);

        if (this.betLimitPopupref != undefined && this.usertypecode == 'PLST') {
          this.betLimitPopupref.destroy();
          this.betLimitPopupref = undefined;
          this.askGameTypeRealOrFun(
            true,
            gameName,
            gameFeatureName,
            betLimitId,
            seatAvailable,
            newtable
          );
          return;
        }
        this.checkBeforeLoadGame(
          gameName,
          gameFeatureName,
          betLimitId,
          seatAvailable,
          newtable,
          undefined,
          this.userBalance,
          roomId
        );
      }
    } else if (gameName === GameConstant.FCB) {
      if (
        this.pageName === PageConstant.FCG ||
        this.pageName === PageConstant.FCB
      ) {
        if (gameFeatureName === GameTypeConstant.LIVEDEALER) {
          if (this.usertypecode == 'PLST') {
            this.checkBeforeLoadGame(
              gameName,
              gameFeatureName,
              betLimitId,
              seatAvailable,
              newtable,
              'playforreal',
              this.userBalance
            );
          } else {
            this.checkBeforeLoadGame(
              gameName,
              gameFeatureName,
              betLimitId,
              seatAvailable,
              newtable,
              undefined,
              this.userBalance
            );
          }
          return;
        }
        //console.log('gameFeatureName');
        //console.log(gameFeatureName);
        const params = {
          type: gameFeatureName,
          seat: seatAvailable,
        };
        this.loadGameService.addItem(
          '3',
          FeatureConstant[gameFeatureName.toUpperCase() + '_LANG']
        );
        if (this.utilService.isDesktopView) {
          this.pageNavigate(PageConstant.FCBTABLES, params);
        } else {
          this.pageNavigate(PageConstant.FCBTABLESMOBILE, params);
        }
      } else if (this.pageName === PageConstant.FCBTABLES) {
        if (this.usertypecode == 'PLST') {
          this.checkBeforeLoadGame(
            gameName,
            gameFeatureName,
            betLimitId,
            seatAvailable,
            newtable,
            'playforreal',
            this.userBalance
          );
        } else {
          this.checkBeforeLoadGame(
            gameName,
            gameFeatureName,
            betLimitId,
            seatAvailable,
            newtable,
            undefined,
            this.userBalance
          );
        }
        return;
      }
    }
  }

  onRTPClick = (event) => {
    //console.log('onRTPClick');
    //console.log(event);
    if (event === GameConstant.FC21) {
      //this.showRTPPopup();
      this.onSelectMenuOnList('premiumpay');
    } else if (event === GameConstant.FCB) {
      this.showTutorialPopup(event);
    }
  };

  onHeaderMenuClick = (event) => {
    //console.log('onHeaderMenuClick');
    //console.log(event);
    if (event == 'info_icon') {
      if (FirebaseConstant.LOBBYMOBILEHEADER['info_icon_' + this.gameNameStr]) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.LOBBYMOBILEHEADER['info_icon_' + this.gameNameStr]
            .eventAction,
          FirebaseConstant.LOBBYMOBILEHEADER['info_icon_' + this.gameNameStr]
            .category,
          FirebaseConstant.LOBBYMOBILEHEADER['info_icon_' + this.gameNameStr]
            .Label,
          FirebaseConstant.LOBBYMOBILEHEADER['info_icon_' + this.gameNameStr]
            .catId,
          FirebaseConstant.LOBBYMOBILEHEADER['info_icon_' + this.gameNameStr]
            .eventId
        );
      }
    }
    if (event == 'favorites_icon') {
      if (this.utilService.isDesktopView) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.LOBBYDESKTOPHEADER['favoritesopen'].eventAction,
          FirebaseConstant.LOBBYDESKTOPHEADER['favoritesopen'].category,
          FirebaseConstant.LOBBYDESKTOPHEADER['favoritesopen'].Label,
          FirebaseConstant.LOBBYDESKTOPHEADER['favoritesopen'].catId,
          FirebaseConstant.LOBBYDESKTOPHEADER['favoritesopen'].eventId
        ); /*'Click', '(B) Lobby Desktop - Header','Favorites',''*/
      } else {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.LOBBYMOBILEHEADER['favoritesopen'].eventAction,
          FirebaseConstant.LOBBYMOBILEHEADER['favoritesopen'].category,
          FirebaseConstant.LOBBYMOBILEHEADER['favoritesopen'].Label,
          FirebaseConstant.LOBBYMOBILEHEADER['favoritesopen'].catId,
          FirebaseConstant.LOBBYMOBILEHEADER['favoritesopen'].eventId
        );
        /*this.firebaseAnalyticsServices.sendAction( 'Click', 'Lobby Mobile - Header','Favorites','');*/
      }
    }
    if (event == 'desktop_icon') {
      if (this.utilService.isDesktopView) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.LOBBYDESKTOPHEADER['desktop_icon'].eventAction,
          FirebaseConstant.LOBBYDESKTOPHEADER['desktop_icon'].category,
          FirebaseConstant.LOBBYDESKTOPHEADER['desktop_icon'].Label,
          FirebaseConstant.LOBBYDESKTOPHEADER['desktop_icon'].catId,
          FirebaseConstant.LOBBYDESKTOPHEADER['desktop_icon'].eventId
        );
      } else {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.LOBBYMOBILEHEADER['desktop_icon'].eventAction,
          FirebaseConstant.LOBBYMOBILEHEADER['desktop_icon'].category,
          FirebaseConstant.LOBBYMOBILEHEADER['desktop_icon'].Label,
          FirebaseConstant.LOBBYMOBILEHEADER['desktop_icon'].catId,
          FirebaseConstant.LOBBYMOBILEHEADER['desktop_icon'].eventId
        );
      }
    }
    if (event == 'mobile_icon') {
      if (this.utilService.isDesktopView) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.LOBBYDESKTOPHEADER['mobile_icon'].eventAction,
          FirebaseConstant.LOBBYDESKTOPHEADER['mobile_icon'].category,
          FirebaseConstant.LOBBYDESKTOPHEADER['mobile_icon'].Label,
          FirebaseConstant.LOBBYDESKTOPHEADER['mobile_icon'].catId,
          FirebaseConstant.LOBBYDESKTOPHEADER['mobile_icon'].eventId
        );
      } else {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.LOBBYMOBILEHEADER['mobile_icon'].eventAction,
          FirebaseConstant.LOBBYMOBILEHEADER['mobile_icon'].category,
          FirebaseConstant.LOBBYMOBILEHEADER['mobile_icon'].Label,
          FirebaseConstant.LOBBYMOBILEHEADER['mobile_icon'].catId,
          FirebaseConstant.LOBBYMOBILEHEADER['mobile_icon'].eventId
        );
      }
    }
    if (event == 'premiumpay_icon') {
      if (!this.utilService.isDesktopView) {
        if (
          FirebaseConstant.LOBBYMOBILEHEADER[
            'premiumpay_icon_' + this.gameNameStr
          ]
        ) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.LOBBYMOBILEHEADER[
              'premiumpay_icon_' + this.gameNameStr
            ].eventAction,
            FirebaseConstant.LOBBYMOBILEHEADER[
              'premiumpay_icon_' + this.gameNameStr
            ].category,
            FirebaseConstant.LOBBYMOBILEHEADER[
              'premiumpay_icon_' + this.gameNameStr
            ].Label,
            FirebaseConstant.LOBBYMOBILEHEADER[
              'premiumpay_icon_' + this.gameNameStr
            ].catId,
            FirebaseConstant.LOBBYMOBILEHEADER[
              'premiumpay_icon_' + this.gameNameStr
            ].eventId
          );
        }
      }
    }
    if (PageConstant.hasOwnProperty(event.toUpperCase())) {
      if (this.utilService.isDesktopView) {
        this.pageNavigate(event);
        if (FirebaseConstant.LOBBYDESKTOPHEADER[event]) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.LOBBYDESKTOPHEADER[event].eventAction,
            FirebaseConstant.LOBBYDESKTOPHEADER[event].category,
            FirebaseConstant.LOBBYDESKTOPHEADER[event].Label,
            FirebaseConstant.LOBBYDESKTOPHEADER[event].catId,
            FirebaseConstant.LOBBYDESKTOPHEADER[event].eventId
          );
        }
      } else {
        this.pageNavigate(event + 'mobile');
        if (FirebaseConstant.LOBBYMOBILEHEADER[event]) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.LOBBYMOBILEHEADER[event].eventAction,
            FirebaseConstant.LOBBYMOBILEHEADER[event].category,
            FirebaseConstant.LOBBYMOBILEHEADER[event].Label,
            FirebaseConstant.LOBBYMOBILEHEADER[event].catId,
            FirebaseConstant.LOBBYMOBILEHEADER[event].eventId
          );
        }
      }

      return;
    }

    if (event.split('_')[1].toLowerCase() === 'icon') {
      if (
        event.split('_')[0].toLowerCase() === PageConstant.DESKTOP ||
        event.split('_')[0].toLowerCase() === PageConstant.MOBILE
      ) {
        this.utilService.isViewChangedByUser = true;
      }
      if (event === 'settings_icon') {
        //console.log("gameName",this.gameName);
        this.onHeaderIconClick(
          this.gameName + event.split('_')[0].toLowerCase()
        );
      } else {
        this.onHeaderIconClick(event.split('_')[0].toLowerCase());
      }

      return;
    }
  };

  gameNameEmit = (data) => {
    this.gameNameStr = data;
    //console.log('GameName');
    //console.log(this.gameNameStr);
  };

  onHeaderIconClick(iconName, isResize = false) {
    //console.log('onHeaderIconClick',iconName);

    let factory;
    if (iconName === 'info') {
      // if (this.utilService.isDesktopView) {
      factory = this.componentFactoryResolver.resolveComponentFactory(
        SelectInfoLayoutDesktopComponent
      );
      /*} else {
       this.loadGameService.openTutorial(this.gameNameStr, 1, this.currentLanguage);
       return;
       }*/
    } else if (iconName === 'settings') {
      factory = this.componentFactoryResolver.resolveComponentFactory(
        SelectSettingsLayoutDesktopComponent
      );
    } else if (iconName === 'history') {
      if (this.utilService.isDesktopView) {
        factory = this.componentFactoryResolver.resolveComponentFactory(
          SelectHistoryLayoutDesktopComponent
        );
      } else {
        // //console.log(iconName);
        return;
      }
    } else if (iconName === 'favorites') {
      if (this.utilService.isDesktopView) {
        this.showFavoritePopup();
        return;
      } else {
        this.showMobileFavorite();
        return;
      }
    } else if (iconName === 'premiumpay') {
      this.onSelectMenuOnList(iconName);
      return;
    } else if (iconName === 'handranks') {
      this.onSelectMenuOnList(iconName);
      return;
    } else if (iconName === 'handrankdetails') {
      this.onSelectMenuOnList(iconName);
      return;
    } else if (iconName === 'handrankdealdrawdetails') {
      this.onSelectMenuOnList(iconName);
      return;
    } else if (iconName === 'fc21settings' || iconName === 'fcbsettings') {
      this.onSelectMenuOnList('settings');
    } else if (iconName === 'symbols') {
      factory = this.componentFactoryResolver.resolveComponentFactory(
        SelectSymbolsLayoutDesktopComponent
      );
    } else if (
      iconName === PageConstant.DESKTOP ||
      iconName === PageConstant.MOBILE
    ) {
      if (!isResize && this.popupref) {
        this.popupref.destroy();
      }
      this.utilService.viewMode = iconName;
      //console.log(this.utilService.isDesktopView);
      //console.log(this.pageName);
      //console.log(this.params);
      if (this.utilService.isDesktopView) {
        if (this.params.seat) {
          if (this.gameType === FeatureConstant.LIVEDEALER) {
            this.params.seat = 7;
          } else {
            this.params.seat = 5;
          }
          if (this.pageName == 'fcbtables') {
            this.params.seat = 1;
          }
        }
      }
      // (<HTMLTextAreaElement>document.getElementById('loggerr')).value += '\n pageNavigate 1111111212121';
      this.pageNavigate(
        this.checkDeviceAndNavigate(this.pageName),
        this.params,
        false,
        isResize
      );
    }
    this.showPopUp(factory);
  }
  decode(s) {
    return decodeURIComponent(s.replace(/\+/g, ' '));
  }

  getQueryStrings() {
    const assoc = {};
    const queryString = location.search.substring(1);
    const keyValues = queryString.split('&');
    for (const i in keyValues) {
      if (keyValues.hasOwnProperty(i)) {
        const key = keyValues[i].split('=');
        if (key.length > 1) {
          assoc[this.decode(key[0])] = this.decode(key[1]);
        }
      }
    }
    return assoc;
  }
  /*window.open(url,'','fullscreen=yes')*/
  pageNavigate(
    page: PageConstant,
    params: any = {},
    logout = false,
    isResize = false
  ) {
    //console.log('pageNavigate--------->', page, params);

    if (logout) {
      clearInterval(this.giInfoInterval);
      const params_pageNavigate: any = this.getQueryStrings();
      //console.log('params_pageNavigate',params_pageNavigate);
      let tempParam = [];
      tempParam = Object.keys(params_pageNavigate);
      //console.log('params_pageNavigate params1 --1',tempParam);
      for (let index = 0; index < tempParam.length; index++) {
        delete tempParam[index];
      }
      this.userService.user.initialusertype = undefined;
      this.userService.user.appusertype = undefined;
      this.userService.user.isFlyLogin = false;
      this.userService.user.isGameStarted = false;
      this.translate.use('en');
      const routeTo = `/${page}`;
      //console.log('params_pageNavigate params1 --2',tempParam);
      this.router.navigate([routeTo], {
        queryParams: tempParam,
      });
    } else {
      if (!isResize) {
        clearInterval(this.giInfoInterval);
      }
      params.sessiontoken = this.userService.user.sessiontoken;
      params.currentPage = page;
      // params.t = Date.now();
      // (<HTMLTextAreaElement>document.getElementById('loggerr')).value += '\n pageNavigate' + page;
      //console.log("this.userService.user.isAutoFullScreenDone-------1",this.userService.user.isAutoFullScreenDone,page);
      /* if(this.userService.user.isAutoFullScreenDone
          && page != PageConstant.INDEX
          && page != PageConstant.INDEXMOBILE
          && page != PageConstant.HISTORYSUMMARY
          && page != PageConstant.HISTORYSUMMARYCONDENSED
          && page != PageConstant.HISTORYDETAIL){
         this.fullscreenAction('full screen');
         this.userService.user.isAutoFullScreenDone = false;
         //console.log("this.userService.user.isAutoFullScreenDone-------2",this.userService.user.isAutoFullScreenDone);
       }*/
      // console.log('removeResizeEventHandler Page Navigatge', page, this.pageName);
      if (page != this.pageName) {
        this.removeResizeEventHandler();
      }
      this.router.navigate(['/' + page], {
        queryParams: params,
      });
    }
  }
  /*----------------------*/
  fullscreenAction(data) {
    //console.log('this.userService.user.fullscreen',this.userService.user.fullscreen);
    const deviceNameID: DeviceName = this.utilService.getDeviceName();
    if (
      deviceNameID === DeviceName.IPHONE ||
      deviceNameID === DeviceName.IPAD ||
      (this.userService.user.isRelaxgame &&
        this.userService.user.fullscreen == false)
    )
      return;
    //console.log("data------>",data,'document.fullscreenElement',document.fullscreenElement)
    let fullScreenMode = document.fullscreenElement;
    //this.isFullScreen = true;
    if (fullScreenMode) {
      //this.enter_full_screen(false);
    } else {
      this.isFullScreen = true;
      this.enter_full_screen(true);
    }
  }
  screenChangeHandler = () => {
    this.removeEventListenerScroll();
    //console.log("screenChangeHandler common.layout  ",this.isFullScreen);
    let fullScreenMode = document.fullscreenElement;
    //let fullScreenMode = document.documentElement;
    if (fullScreenMode) {
      this.isFullScreen = true;
    } else {
      this.isFullScreen = false;
    }
  };
  /*
It is Element.webkitRequestFullscreen, lower-case s in Fullscreen.
Only Firefox did set their vendor-prefixed version with a camel-cased FullScreen
var requestFullScreen = docEl.requestFullscreen || docEl.webkitRequestFullscreen || docEl.mozRequestFullScreen ||  docEl.msRequestFullscreen;
*/
  enter_full_screen(status) {
    let elem = document.getElementById('main');
    let calls;
    if (status) {
      calls = [
        'requestFullscreen',
        'webkitRequestFullscreen',
        'mozRequestFullScreen',
        'msRequestFullscreen',
      ];
      for (let i = 0; i < calls.length; i++) {
        if (elem[calls[i]]) {
          elem[calls[i]]();
          return;
        }
      }
    } else {
      calls = [
        'exitFullscreen',
        'webkitExitFullscreen',
        'mozCancelFullScreen',
        'msExitFullscreen',
      ];
      for (let i = 0; i < calls.length; i++) {
        if (document[calls[i]]) {
          document[calls[i]]();
          return;
        }
      }
    }
  }
  /*--------*/
  showPopUp(factory) {
    if (factory) {
      if (this.popupref) {
        this.popupref.destroy();
      }
      this.popupref = this.viewContainerRef.createComponent(factory);
      this.popupref.instance['data'] = {
        ref: this.popupref,
        currentLanguage: this.currentLanguage,
      };
      this.popupref.instance['eventEmit'].subscribe((data) => {
        //console.log(data);
        if (data === 'close') {
          this.popupref.destroy();
        }
        if (data.split('_')[0] === 'symbols') {
          this.popupref.destroy();
          this.showTutorialPopup(GameConstant.FC21, data.split('_')[1]);
        }
        if (data.split('_')[0] === 'info') {
          this.displaySelectedInformation(data);
        }
        if (data.split('_')[0] === 'history') {
          this.popupref.destroy();
          //console.log('Show History: ' + data.split('_')[2]);
          if (data.split('_')[2] === 'fc21') {
            this.showHistory(data.split('_')[2]);
          }
        }
      });
    }
  }
  /**
   *  getAvailableSeatTableInfoMethod  follow to showLiveDealerBetLimitPopup
   * @param checkTable
   * @param gameDetails
   */
  getAvailableSeatTableInfoMethod = (
    checkTable,
    gameDetails?,
    loadfromFaV?,
    obj?
  ) => {
    //console.log('getAvailableSeatTableInfoMethod,checkTable,gameDetails',checkTable,gameDetails,loadfromFaV,obj);

    let CurrentLiveDealerTableLimitArray;
    this.betLimitService
      .getAvailableSeatTableInfo(gameDetails.tableid)
      .subscribe((availability) => {
        //console.log("this.betLimitService.getAvailableSeatTableInfo", availability);
        /* {"isseatsavailable":true,"tableid":"fcg21nv8sv7rk1jk","status":"Success"} */
        /* {"tabletype": "fcg21nv8sv7rk1jk","gameType": "livedealer","tableid": "fcg21nv8sv7rk1jk"} */
        if (availability.isseatsavailable) {
          // && false
          this.betLimitService
            .getLiveBetLimitByID(availability.tableid)
            .subscribe((limits) => {
              //console.log("this.betLimitService.getLiveBetLimitByID", limits);
              if (loadfromFaV) {
                //console.log('getAvailableSeatTableInfoMethod,checkTable,gameDetails',checkTable,gameDetails,loadfromFaV,obj);
                let gameDetailsobj: any = {};
                gameDetailsobj.tabletype = availability.tableid;
                gameDetailsobj.gameType = 'livedealer';
                gameDetailsobj.tableid = availability.tableid;
                this.checkLiveDealerSeatsAvailability(
                  'fc21',
                  'livedealer',
                  obj.betlimitid,
                  '7',
                  '0',
                  gameDetailsobj
                );
                return;
              }
              CurrentLiveDealerTableLimitArray = [
                ...limits[availability.tableid],
              ];
              gameDetails.tabletype = availability.tableid;
              gameDetails.tableid = availability.tableid;
              this.isPlayNow = true;
              this.showBetLimitPopup(
                checkTable,
                CurrentLiveDealerTableLimitArray,
                gameDetails
              );
            });
        } else {
          let LDSeatsObj: any = {};
          LDSeatsObj.userId = this.userService.user.userId;

          this.AlertLiveDealerNoSeatAvailableTrigger(LDSeatsObj);
          return;
        }
      });
  };
  /**
   * showLiveDealerBetLimitPopup call from fc21tables.layout.component.ts
   * @param checkTable
   * @param gameDetails
   */
  showLiveDealerBetLimitPopup = (
    checkTable = 'livedealer',
    gameDetails?,
    loadfromFaV?,
    obj?
  ) => {
    /* gameDetails-======>{"tabletype": "fcg21nv8sv7rk1jk","gameType": "livedealer","tableid": "fcg21nv8sv7rk1jk" } */
    //console.log('showBetLimitPopup------------>',checkTable,gameDetails,loadfromFaV,obj);
    if (checkTable == 'livedealer') {
      this.isPlayNow = false;
      if (this.userService.user.usertypecode == 'PLST') {
        this.betLimitService
          .playForFunCheckLogin('playforreal')
          .subscribe((response) => {
            this.isChangePlstTOReal = true;
            this.getAvailableSeatTableInfoMethod(
              checkTable,
              gameDetails,
              loadfromFaV,
              obj
            );
          });
      } else {
        this.getAvailableSeatTableInfoMethod(
          checkTable,
          gameDetails,
          loadfromFaV,
          obj
        );
      }
    }
  };
  showBetLimitPopup(
    checkTable = 'LiveCasino',
    CurrentLiveDealerTableLimitArray?,
    gameDetails?,
    isfromFavorite?
  ) {
    //console.log('showBetLimitPopup------->checkTable', checkTable, 'CurrentLiveDealerTableLimitArray', CurrentLiveDealerTableLimitArray, 'gameDetails', gameDetails);
    if (checkTable == 'livedealer') {
      this.liveDealerLimitgameDetailsArr = {};
      this.liveDealerLimitArr = [];
      this.liveDealerLimitArr = [...CurrentLiveDealerTableLimitArray];
      gameDetails.currentLanguage = this.currentLanguage;
      this.liveDealerLimitgameDetailsArr = gameDetails;
    }
    //console.log('showBetLimitPopup checkTable',checkTable);

    if (this.utilService.isDesktopView) {
      this.updateParentScroll();
      if (this.betLimitPopupref) {
        this.betLimitPopupref.destroy();
      }
      const factory = this.componentFactoryResolver.resolveComponentFactory(
        TableLimitsLayoutDesktopComponent
      );
      this.betLimitPopupref = this.viewContainerRef.createComponent(factory);
      this.betLimitPopupref.instance['data'] = {
        ref: this.betLimitPopupref,
        userCurrency: this.userCurrencyCode,
        betLimits:
          checkTable == 'LiveCasino'
            ? this.liveCasinoLimitArr
            : CurrentLiveDealerTableLimitArray,
        currencySymbol: this.betLimitService.currencySymbol,
        gameTableName: checkTable == 'LiveCasino' ? 'LiveCasino' : 'livedealer',
        isfromFavorite: isfromFavorite ? isfromFavorite : '',
        currentLanguage: this.currentLanguage,
      };
      this.betLimitPopupref.instance['eventEmit'].subscribe((data) => {
        //console.log('this.betLimitPopupref.instancesubscribe', data);
        if (data.status == 'close') {
          this.betLimitPopupref.destroy();
          this.betLimitPopupref = undefined;

          if (this.isChangePlstTOReal) {
            this.betLimitService
              .playForFunCheckLogin('playforfun')
              .subscribe((response) => {
                //console.log('playForFunCheckLogin---->session token changed',response);
                this.isChangePlstTOReal = false;
              });
          }
          console.log(
            "🚀 ~ this.betLimitPopupref.instance['eventEmit'].subscribe ~ checkTable:",
            checkTable
          );
          console.log(
            "🚀 ~ this.betLimitPopupref.instance['eventEmit'].subscribe ~ this.noLiveDealerSeats:",
            this.noLiveDealerSeats
          );

          if (!data?.gameTableName && this.noLiveDealerSeats) {
            if (this.utilService.isDesktopView) {
              this.pageNavigate(PageConstant.FCG);
            } else {
              this.pageNavigate(PageConstant.FCGMOBILE);
            }
          }
        }
        if (data.gameTableName == 'LiveCasino' && data.status != 'close') {
          this.loadGameFromBetLimitPopup(data);
        } else if (
          data.gameTableName == 'livedealer' &&
          data.status != 'close'
        ) {
          if (isfromFavorite == 'fromFavorite') {
            //console.log('gameDetails============this.onFavoritesIconClick',gameDetails);
            let betLimit = CurrentLiveDealerTableLimitArray.filter(
              (x) => x.betlimitid === data.betlimitid
            )[0];
            gameDetails.max = betLimit.max;
            gameDetails.min = betLimit.min;
            gameDetails.betlimitid = data.betlimitid;
            //console.log('gameDetails============this.onFavoritesIconClick2',gameDetails);
            this.onFavoritesIconClick(gameDetails);
            this.betLimitPopupref.destroy();
            this.betLimitPopupref = undefined;
            return;
          }
          //fc21 livedealer 1 7 0 undefined
          /* gameDetails-======>{"tabletype": "fcg21nv8sv7rk1jk","gameType": "livedealer","tableid": "fcg21nv8sv7rk1jk" } */
          this.checkLiveDealerSeatsAvailability(
            'fc21',
            'livedealer',
            data.betlimitid,
            '7',
            '0',
            gameDetails
          );
          this.betLimitPopupref.destroy();
          this.betLimitPopupref = undefined;
        }
      });
    } else {
      this.showSlideFav = true;
      this.mobileTableLimitGameName = checkTable;
      this.stateValBetLimit = 'enterfromright';
      //this.showSlidwTableLimit = true;
      this.scrollListen();
      this.addEventListenerScroll();
    }
  }

  loadGameFromBetLimitPopup(data) {
    //console.log('loadGameFromBetLimitPopup', data);

    if (!this.utilService.isDesktopView) {
      if (this.stateValBetLimit === 'static') {
        this.stateValBetLimit = 'leavetoright';
        this.showSlidwTableLimit = false;
        this.removeEventListenerScroll();
        this.showSlideFav = false;
      }
    }
    if (data == 'close' || data.status == 'close') {
      if (this.isChangePlstTOReal) {
        this.betLimitService
          .playForFunCheckLogin('playforfun')
          .subscribe((response) => {
            //console.log('playForFunCheckLogin---->session token changed', response);
            this.isChangePlstTOReal = false;
          });
      }
      return;
    }
    if (
      data.betlimitid !== 0 &&
      data.gameTableName == 'LiveCasino' &&
      data.status != 'close'
    ) {
      //console.log('this.buildGameInfo(FeatureConstant.LIVECASINO, data, GameConstant.FC21)',this.buildGameInfo(FeatureConstant.LIVECASINO, data, GameConstant.FC21));

      this.onIconClick(
        this.buildGameInfo(FeatureConstant.LIVECASINO, data, GameConstant.FC21),
        true
      );
    } else if (data.gameTableName == 'livedealer' && data.status != 'close') {
      //fc21 livedealer 1 7 0 undefined
      console.log(
        'loadGameFromBetLimitPopup============this.onFavoritesIconClick',
        data
      );

      if (data.liveDealerLimitgameDetailsArr.from == 'fromFavorite') {
        //console.log('loadGameFromBetLimitPopup============this.fromFavorite',data);
        let betLimit = this.liveDealerBetLimitArr.filter(
          (x) => x.betlimitid === data.betlimitid
        )[0];
        data.liveDealerLimitgameDetailsArr.max = betLimit.max;
        data.liveDealerLimitgameDetailsArr.min = betLimit.min;
        data.liveDealerLimitgameDetailsArr.betlimitid = data.betlimitid;
        //console.log('loadGameFromBetLimitPopup============this.fromFavorite2',data);
        this.onFavoritesIconClick(data.liveDealerLimitgameDetailsArr);
        this.stateValBetLimit = 'leavetoright';
        this.showSlidwTableLimit = false;
        this.removeEventListenerScroll();
        this.showSlideFav = false;
        return;
      } else {
        this.checkLiveDealerSeatsAvailability(
          'fc21',
          'livedealer',
          data.betlimitid,
          '7',
          '0',
          data.liveDealerLimitgameDetailsArr
        );
      }
    }
  }
  checkLiveDealerSeatsAvailability = (
    gameName,
    gameFeature,
    betLimitId,
    seatAvailable,
    newTable,
    gameDetails?
  ) => {
    //console.log('checkLiveDealerSeatsAvailability');
    //console.log(gameName + 'livedealertableid');
    //console.log('gameDetails.tableid',gameDetails.tableid);
    //console.log('gameName, gameFeature, betLimitId, seatAvailable, newTable, gameDetails',gameName, gameFeature, betLimitId, seatAvailable, newTable, gameDetails);
    this.isPlayNow = false;
    GameConstant[(gameName + 'livedealertableid').toUpperCase()] =
      gameDetails.tableid;
    this.loadGame(
      gameName,
      gameFeature,
      betLimitId,
      seatAvailable,
      newTable,
      null,
      true
    );
  };

  loadGameFromUrl(gameIdFromUrl: string, serverURL: string) {
    const gameParams = getGameParameters(gameIdFromUrl);
    console.log('gameParams', JSON.stringify(gameParams));
    if (gameParams.gameFeature === GameTypeConstant.LOBBY) {
      this.pageNavigate(PageConstant.FCG);
      return;
    }
    if (gameParams.betLimitId === 'Lobby') {
      this.navigateToSameTablePage(tableTypeMap[gameParams.tableType], 5);
      return;
    }
    if (gameParams.gameFeature === GameTypeConstant.LOBBY) {
      return;
    }
    if (gameParams) {
      this.loadGameService.loadGame(
        gameParams.gameName,
        gameParams.gameFeature,
        gameParams.betLimitId,
        gameParams.seatAvailable,
        gameParams.roomId,
        gameParams.newTable,
        serverURL,
        gameParams.rewriteURL,
        gameParams.historyURL,
        gameParams.tableId
      );
    } else {
      console.error('Could not extract game parameters from game ID');
    }
  }

  checkBeforeLoadGame = (
    gameName,
    gameFeature,
    betLimitId,
    seatAvailable,
    newTable = 0,
    playForFunCheckLogin = undefined,
    currentBalance,
    roomId?
  ) => {
    // console.log(
    //   'checkBeforeLoadGame  gameName, gameFeature, betLimitId, seatAvailable, newTable = 0, playForFunCheckLogin = undefined,currentBalance',
    //   gameName,
    //   gameFeature,
    //   betLimitId,
    //   seatAvailable,
    //   newTable,
    //   playForFunCheckLogin,
    //   currentBalance
    // );

    if (this.userService.user.first_name == 'UR-Viasino') {
      this.AlertRegisterPopupTrigger();
      return;
    } else if (this.userService.user.player_isblocked) {
      this.commonAlertPopupTrigger();
      return;
    } else if (currentBalance < this.userService.user.gameminbet) {
      this.AlertInsufficientPopupTrigger('real');
      return;
    } else {
      if (playForFunCheckLogin != undefined) {
        this.betLimitService
          .playForFunCheckLogin(playForFunCheckLogin)
          .subscribe((response) => {
            this.isChangePlstTOReal = true;
            //console.log('checkBeforeLoadGame1')
            this.loadGame(
              gameName,
              gameFeature,
              betLimitId,
              seatAvailable,
              roomId,
              newTable
            );
          });
      } else {
        //console.log('checkBeforeLoadGame12')
        this.loadGame(
          gameName,
          gameFeature,
          betLimitId,
          seatAvailable,
          roomId,
          newTable
        );
      }
    }
  };
  /**
   * loadGameFromFunAlertPopup method parameter get from user selection from play for fun or real popup
   * @param data
   */
  loadGameFromFunAlertPopup(data) {
    //console.log("data,loadGameFromFunAlertPopup",data)
    //TODO this.gameTypeRealOrFunOption example
    /**   "inSufficientFund": true, "isGameTypeRealOrFunPopUpEnable": true, "gameName": "fc21", "gameFeatureName": "private", "betLimitId": "8", "seatAvailable": "5", "newtable": 0 "tableIndex": 1 "activePlayType": 1*/ /*  this.usertypecode  ===>
     * PLSTPLAYROBT*/
    if (data !== 0) {
      if (data.activePlayType == 11) {
        /*TODO this condition to play for real livedealer*/ if (
          this.usertypecode != 'PLAY'
        ) {
          if (this.userService.user.first_name == 'UR-Viasino') {
            this.AlertRegisterPopupTrigger();
            return;
          } else if (this.userService.user.player_isblocked) {
            this.commonAlertPopupTrigger();
            return;
          } else if (this.userBalance < this.userService.user.gameminbet) {
            this.AlertInsufficientPopupTrigger('real');
            return;
          } else {
            this.isGameTypeRealOrFunPopUpEnable = false;
            //console.log('this.fc21Array[0].isComingSoon',this.fc21Array[0].isComingSoon,'this.fc21Array[0].isSecret',this.fc21Array[0].isSecret);
            if (!this.fc21Array[0].isComingSoon) {
              this.navigateToSameTablePage('livedealer', 7);
            } else {
              this.onIconClick(
                'livedealer_fc21_' +
                  this.fc21Array[0].isComingSoon +
                  '_1_7_0_' +
                  this.fc21Array[0].isSecret
              );
            }
          }
        }
      } else if (data.activePlayType == 1) {
        /*TODO this condition to play for real livecasino*/ if (
          this.usertypecode != 'PLAY'
        ) {
          this.checkBeforeLoadGame(
            'fc21',
            'livecasino',
            data.betLimitId > 5
              ? parseInt(data.betLimitId) - 5
              : data.betLimitId,
            '5',
            0,
            'playforreal',
            this.userBalance,
            this.currentRoomId
          );
        } else {
          this.checkBeforeLoadGame(
            'fc21',
            'livecasino',
            data.betLimitId > 5
              ? parseInt(data.betLimitId) - 5
              : data.betLimitId,
            '5',
            0,
            undefined,
            this.userBalance
          );
        }
      } else if (data.activePlayType == 2) {
        /*TODO this condition to play for real private*/ if (
          this.usertypecode != 'PLAY'
        ) {
          this.checkBeforeLoadGame(
            'fc21',
            'private',
            data.gameFeatureName == 'livecasino'
              ? parseInt(data.betLimitId) + 5
              : data.betLimitId,
            data.gameFeatureName == 'livecasino' ? 5 : data.seatAvailable,
            0,
            'playforreal',
            this.userBalance
          );
        } else {
          this.checkBeforeLoadGame(
            'fc21',
            'private',
            data.gameFeatureName == 'livecasino'
              ? parseInt(data.betLimitId) + 5
              : data.betLimitId,
            data.gameFeatureName == 'livecasino' ? 5 : data.seatAvailable,
            0,
            undefined,
            this.userBalance
          );
        }
      } else if (data.activePlayType == 3) {
        /*TODO this condition to play for fun private*/ if (
          this.usertypecode != 'PLST'
        ) {
          this.checkBeforeLoadGame(
            'fc21',
            'private',
            6,
            data.gameFeatureName == 'livecasino' ? 5 : data.seatAvailable,
            0,
            'playforfun',
            this.userBalance
          );
        } else {
          this.checkBeforeLoadGame(
            'fc21',
            'private',
            6,
            data.gameFeatureName == 'livecasino' ? 5 : data.seatAvailable,
            0,
            undefined,
            this.funUserBalance
          );
        }
      }
      return;
    }
  }

  displaySelectedInformation(data) {
    if (data.split('_')[1] === 'new') {
      this.loadWebsite(data.split('_')[2]);
    }

    if (data.split('_')[1] === 'popup') {
      this.showTutorialPopup(data.split('_')[2]);
    }
  }

  showFavoritePopup() {
    if (this.popupref) {
      this.popupref.destroy();
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      FavoriteInfoLayoutDesktopComponent
    );
    this.popupref = this.viewContainerRef.createComponent(factory);
    this.popupref.instance['data'] = {
      ref: this.popupref,
      currentLanguage: this.currentLanguage,
      userCurrency: this.userCurrencyCode,
      favoriteList: this.favoriteArray,
    };
    this.popupref.instance['eventEmit'].subscribe((data) => {
      //console.log(data);
      if (data.action === 'close') {
        if (!this.betLimitPopupref) {
          this.popupref.destroy();
        }
      }
      if (data.action === 'delete') {
        this.updateFavoriteArray(data.item);
        this.showFavoritePopup();
      }
      if (data.action === 'play') {
        // this.popupref.destroy();
        if (this.usertypecode == 'PLST') {
          if (this.showSlideFav === true) {
            this.stateValFav = 'leavetoright';
            this.removeEventListenerScroll();
            this.showSlideFav = false;
          }
        }
        this.popupref.destroy();
        this.loadGameFromFavorite(data.item);
      }
      if (data.action === 'rearrange') {
        this.rearrangeFavorite(data);
      }
    });
  }

  rearrangeFavorite(data) {
    moveItemInArray(this.favoriteArray, data.previousIndex, data.currentIndex);
    if (!this.isLocalEnv) {
      this.callPlayerFavoriteForTable(true);
    } else {
      this.updateFavoritesArray('{"favorites":[]}');
    }
  }

  showMobileFavorite() {
    this.stateValFav = 'enterfromright';
    this.showSlideFav = true;
    this.scrollListen();
    this.addEventListenerScroll();
  }

  loadGameFromFavorite = (obj) => {
    //console.log('loadGameFromFavorite +obj',obj);
    /*obj------> device: "device_portrait", favId: "undefined_7", gameName: "fc21", gameType: "LANG00128", max: 1000, min: 5, seatavailable: "7", select: 0, tableType: "livedealer", tableid: "fcg21nv8sv7rk1jk", title: "fcg21nv8sv7rk1jk" */
    if (this.utilService.isDesktopView) {
      if (
        FirebaseConstant.FC21LCDesktop['favorites' + obj.betlimitid] &&
        obj.tableType == 'livecasino'
      ) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.FC21LCDesktop['favorites' + obj.betlimitid]
            .eventAction,
          FirebaseConstant.FC21LCDesktop['favorites' + obj.betlimitid].category,
          FirebaseConstant.FC21LCDesktop['favorites' + obj.betlimitid].Label,
          FirebaseConstant.FC21LCDesktop['favorites' + obj.betlimitid].catId,
          FirebaseConstant.FC21LCDesktop['favorites' + obj.betlimitid].eventId
        );
      }
      if (
        FirebaseConstant.FC21PT5HDesktop['favorites' + obj.betlimitid] &&
        obj.tableType == 'private' &&
        obj.seatavailable == 5
      ) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.FC21PT5HDesktop['favorites' + obj.betlimitid]
            .eventAction,
          FirebaseConstant.FC21PT5HDesktop['favorites' + obj.betlimitid]
            .category,
          FirebaseConstant.FC21PT5HDesktop['favorites' + obj.betlimitid].Label,
          FirebaseConstant.FC21PT5HDesktop['favorites' + obj.betlimitid].catId,
          FirebaseConstant.FC21PT5HDesktop['favorites' + obj.betlimitid].eventId
        );
      }
    } else {
      if (
        FirebaseConstant.FC21LCMOBILE['favorites' + obj.betlimitid] &&
        obj.tableType == 'livecasino'
      ) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.FC21LCMOBILE['favorites' + obj.betlimitid]
            .eventAction,
          FirebaseConstant.FC21LCMOBILE['favorites' + obj.betlimitid].category,
          FirebaseConstant.FC21LCMOBILE['favorites' + obj.betlimitid].Label,
          FirebaseConstant.FC21LCMOBILE['favorites' + obj.betlimitid].catId,
          FirebaseConstant.FC21LCMOBILE['favorites' + obj.betlimitid].eventId
        );
      }
      if (
        FirebaseConstant.FC21PT5HMOBILE['favorites' + obj.betlimitid] &&
        obj.tableType == 'private' &&
        obj.seatavailable == 5
      ) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.FC21PT5HMOBILE['favorites' + obj.betlimitid]
            .eventAction,
          FirebaseConstant.FC21PT5HMOBILE['favorites' + obj.betlimitid]
            .category,
          FirebaseConstant.FC21PT5HMOBILE['favorites' + obj.betlimitid].Label,
          FirebaseConstant.FC21PT5HMOBILE['favorites' + obj.betlimitid].catId,
          FirebaseConstant.FC21PT5HMOBILE['favorites' + obj.betlimitid].eventId
        );
      }
      if (
        FirebaseConstant.FC21PT2HMOBILE['favorites' + obj.betlimitid] &&
        obj.tableType == 'private' &&
        obj.seatavailable == 2
      ) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.FC21PT2HMOBILE['favorites' + obj.betlimitid]
            .eventAction,
          FirebaseConstant.FC21PT2HMOBILE['favorites' + obj.betlimitid]
            .category,
          FirebaseConstant.FC21PT2HMOBILE['favorites' + obj.betlimitid].Label,
          FirebaseConstant.FC21PT2HMOBILE['favorites' + obj.betlimitid].catId,
          FirebaseConstant.FC21PT2HMOBILE['favorites' + obj.betlimitid].eventId
        );
      }
      if (
        FirebaseConstant.FC21PT3HMOBILE['favorites' + obj.betlimitid] &&
        obj.tableType == 'private' &&
        obj.seatavailable == 3
      ) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.FC21PT3HMOBILE['favorites' + obj.betlimitid]
            .eventAction,
          FirebaseConstant.FC21PT3HMOBILE['favorites' + obj.betlimitid]
            .category,
          FirebaseConstant.FC21PT3HMOBILE['favorites' + obj.betlimitid].Label,
          FirebaseConstant.FC21PT3HMOBILE['favorites' + obj.betlimitid].catId,
          FirebaseConstant.FC21PT3HMOBILE['favorites' + obj.betlimitid].eventId
        );
      }
    }
    //console.log('loadGameFromFavorite  obj',obj,'his.usertypecode,',this.usertypecode);

    if (obj.betlimitid !== 0) {
      if (this.usertypecode == 'PLST') {
        if (this.userService.user.first_name == 'UR-Viasino') {
          this.AlertRegisterPopupTrigger();
          return;
        } else if (this.userService.user.player_isblocked) {
          this.commonAlertPopupTrigger();
          return;
        } else if (this.funUserBalance < this.userService.user.gameminbet) {
          this.AlertInsufficientPopupTrigger('fun');
          return;
        } else {
          this.askGameTypeRealOrFun(
            true,
            obj.gameName,
            obj.tableType,
            obj.betlimitid,
            obj.seatavailable,
            0
          );
        }
      } else {
        if (obj.gameType == 'LANG00128') {
          let gameDetails: any = {};
          gameDetails.tabletype = obj.tableid;
          gameDetails.gameType = 'livedealer';
          gameDetails.tableid = obj.tableid;
          gameDetails.gameName = obj.gameName;

          if (!this.fc21Array[0].isComingSoon) {
            this.showLiveDealerBetLimitPopup(
              'livedealer',
              gameDetails,
              true,
              obj
            );
            return;
          } else {
            this.stateValFav = 'leavetoright';
            this.removeEventListenerScroll();
            this.showSlideFav = false;
            this.onIconClick(
              'livedealer_fc21_' +
                this.fc21Array[0].isComingSoon +
                '_1_7_0_' +
                this.fc21Array[0].isSecret,
              false,
              'livedealer',
              gameDetails
            );
          }
        } else {
          this.checkBeforeLoadGame(
            obj.gameName,
            obj.tableType,
            obj.betlimitid,
            obj.seatavailable,
            0,
            undefined,
            this.userBalance
          );
        }
      }
    } else {
      //console.log('showBetLimit Popup--2');
      this.showBetLimitPopup();
    }
  };

  onMobileFavAction = (data) => {
    //console.log('onMobileFavAction',data);
    if (data.action === 'close') {
      if (this.showSlideFav === true) {
        this.stateValFav = 'leavetoright';
        this.removeEventListenerScroll();
        this.showSlideFav = false;
      }
    }
    if (data.action === 'delete') {
      this.updateFavoriteArray(data.item);
    }
    if (data.action === 'play') {
      if (this.usertypecode == 'PLST') {
        if (this.showSlideFav === true) {
          this.stateValFav = 'leavetoright';
          this.removeEventListenerScroll();
          this.showSlideFav = false;
        }
      }
      this.loadGameFromFavorite(data.item);
    }
    if (data.action === 'rearrange') {
      this.rearrangeFavorite(data);
    }
  };

  showTutorialPopup(gameName, index = 1) {
    if (this.popupref) {
      this.popupref.destroy();
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      TutorialLayoutDesktopComponent
    );
    this.popupref = this.viewContainerRef.createComponent(factory);
    this.popupref.instance['data'] = {
      ref: this.popupref,
      currentLanguage: this.tempLanguage,
      gamedata: this.gameJSON,
      tutorialContent: TutorialConstant[gameName.toUpperCase()],
      game: gameName,
      index: index,
    };
    this.popupref.instance['eventEmit'].subscribe((data) => {
      //console.log('this.popupref.instance.subscribe(data ',data);
      //console.log(this.gameDetailsStateVal);
      if (this.gameDetailsStateVal == 'nostate') {
        this.addEventListenerScroll();
      }
      if (data === 'close') {
        this.popupref.destroy();
      }
    });
  }

  showRTPPopup(featureName = FeatureConstant.LIVECASINO, rtp?, currency?) {
    if (this.popupref) {
      this.popupref.destroy();
    }
    //console.log(this.betLimitService.fc21JSON);
    let factory;
    if (this.currentMenuName === PageConstant.HISTORYDETAIL) {
      factory = this.componentFactoryResolver.resolveComponentFactory(
        TableInfopopupLayoutDesktopComponent
      );
    } else {
      factory = this.utilService.isDesktopView
        ? this.componentFactoryResolver.resolveComponentFactory(
            TableInfopopupLayoutDesktopComponent
          )
        : this.componentFactoryResolver.resolveComponentFactory(
            TableinfopopupLayoutMobileComponent
          );
    }
    this.popupref = this.viewContainerRef.createComponent(factory);
    this.popupref.instance['data'] = {
      ref: this.popupref,
      currentLanguage: this.currentLanguage,
      currencySymbol: currency
        ? this.betLimitService.getCurrencySymbolByCode(currency)
        : this.betLimitService.currencySymbol,
      info: rtp
        ? this.constructRTPInfo(featureName, rtp)
        : this.betLimitService.fc21JSON[featureName],
    };
    this.popupref.instance['eventEmit'].subscribe((data) => {
      //console.log(data);
      if (data === 'close') {
        this.popupref.destroy();
      }
      if (data.split('_')[0] === 'info') {
        this.showTutorialPopup(GameConstant.FC21, data.split('_')[1]);
      }
    });
  }

  constructRTPInfo(featureName, _rtp) {
    const rtp: FC21RTP = _rtp;
    const gameLobby: FC21Lobby = new FC21Lobby();
    gameLobby.minbet = rtp.minbet;
    gameLobby.maxbet = rtp.maxbet;
    gameLobby.featureName = featureName;
    gameLobby.decks = rtp.decks;
    gameLobby.langCode = FeatureConstant[featureName.toUpperCase() + '_LANG'];
    gameLobby.shuffles = rtp.shufflepercentage + '%';
    gameLobby.splits = rtp.split;
    gameLobby.soft17 = rtp.soft17 === 'true' ? true : false;
    gameLobby.supernatural = rtp.supernatural;
    gameLobby.naturaltwentyone = rtp.naturaltwentyone;
    gameLobby.doublenatural = rtp.doublenatural;
    gameLobby.naturalzero = rtp.naturalzero;
    gameLobby.colorcardinsurance =
      rtp.colorcardinsurance +
      ' / ' +
      this.betLimitService.getRatioPercentage(rtp.colorcardinsurance);
    gameLobby.whitecardinsurance =
      rtp.whitecardinsurance +
      ' / ' +
      this.betLimitService.getRatioPercentage(rtp.whitecardinsurance);
    gameLobby.russianroulette17 =
      rtp.russianroulette17 +
      ' / ' +
      this.betLimitService.getRatioPercentage(rtp.russianroulette17);
    gameLobby.russianroulette18 =
      rtp.russianroulette18 +
      ' / ' +
      this.betLimitService.getRatioPercentage(rtp.russianroulette18);
    gameLobby.russianroulette19 =
      rtp.russianroulette19 +
      ' / ' +
      this.betLimitService.getRatioPercentage(rtp.russianroulette19);
    gameLobby.russianroulette20 =
      rtp.russianroulette20 +
      ' / ' +
      this.betLimitService.getRatioPercentage(rtp.russianroulette20);
    //console.log(gameLobby);
    return gameLobby;
  }
  public isEnableDecoderDesktopPopup = false;
  public isEnableDecoderMobilePopup = false;
  public inputToDecoderPopup;
  onEventEmitDecoderPopup(emitdata) {
    //console.log("onEventEmitDecoderPopup",emitdata);
    /*
    * let emitObj:any = {};
    emitObj.currentLanguage = this.data.currentLanguage;
    emitObj.secretStr = this.data.secretStr;
    emitObj.errorMsg = this.data.errorMsg;
    emitObj.action = 'close';
    * */

    if (emitdata.action === 'close') {
      this.isEnableDecoderDesktopPopup = false;
      this.isEnableDecoderMobilePopup = false;
    } else {
      this.giInfoService
        .getLaunchStatus(emitdata.action)
        .subscribe((response) => {
          //console.log(response);
          if (response.isldskey) {
            this.utilService.isSecretCode = true;
            this.loadGameOrNavigatepage(emitdata.secretStr);
          } else {
            this.showDecoderPopup(emitdata.secretStr, 'Incorrect Code!');
          }
        });

      this.isEnableDecoderDesktopPopup = false;
      this.isEnableDecoderMobilePopup = false;
    }
  }
  showDecoderPopup(secretStr: string, errorMsg: string = '') {
    //this.isEnableDecoderPopup = true;
    this.inputToDecoderPopup = {
      currentLanguage: this.tempLanguage,
      secretStr: secretStr,
      errorMsg: errorMsg,
    };
    if (window.innerWidth > window.innerHeight) {
      this.isEnableDecoderDesktopPopup = true;
      this.isEnableDecoderMobilePopup = false;
      //factory = this.componentFactoryResolver.resolveComponentFactory(DecoderLayoutDesktopComponent);
    } else {
      this.isEnableDecoderMobilePopup = true;
      this.isEnableDecoderDesktopPopup = false;
      //factory = this.componentFactoryResolver.resolveComponentFactory(DecoderLayoutMobileComponent);
    }
  }

  showCommingSoonPopup(iconStr: string = '') {
    //console.log('showCommingSoonPopup',iconStr,this.utilService.isDesktopView,this.popupref);
    this.updateParentScroll();
    if (this.utilService.isDesktopView) {
      if (this.popupref) {
        this.popupref.destroy();
      }
      const factory = this.componentFactoryResolver.resolveComponentFactory(
        ComingSoonLayoutDesktopComponent
      );
      this.popupref = this.viewContainerRef.createComponent(factory);
      this.popupref.instance['data'] = {
        ref: this.popupref,
        currentLanguage: this.tempLanguage,
        iconStr: iconStr,
      };
      this.popupref.instance['eventEmit'].subscribe((data) => {
        //console.log(data);
        if (data === 'close') {
          this.popupref.destroy();
        } else {
          this.checkIsSecret(data);
        }
      });
    } else {
      this.removeMenu();
      this.gameStr = iconStr;
      this.addMenuToListArray(this.menuListObject.comingsoon);
    }
  }

  checkIsSecret = (secretStr: string) => {
    //console.log('checkIsSecret',secretStr);
    if (secretStr != '') {
      const isSecret: boolean =
        secretStr.split('_')[6] === 'true' ? true : false;
      //console.log(isSecret);
      if (isSecret) {
        if (this.popupref) {
          this.popupref.destroy();
        }
        this.removeMenu();
        this.showDecoderPopup(secretStr);
      }
    }
  };

  showErrorPopup(errorData?: ErrorData) {
    if (this.userService.user.isGameStarted) {
      return;
    }
    if (this.popupref) {
      this.popupref.destroy();
    }
    clearInterval(this.giInfoInterval);
    this.userService.user.isSessionActive = false;
    if (errorData?.httpCode === 401) {
      const params: any = getQueryStrings();
      if (params.logoutLobby) {
        this.loadIndexPage();
      }
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      AppErrorLayoutDesktopComponent
    );
    this.popupref = this.viewContainerRef.createComponent(factory);
    this.popupref.instance['data'] = {
      ref: this.popupref,
      currentLanguage: this.tempLanguage,
      httpCode: errorData?.httpCode,
      specificMessageCode: errorData?.specificMessageCode,
      additionalErrorCode: errorData?.additionalErrorCode,
    };
    console.log('stop this.giInfoInterval on 401 error');
    clearInterval(this.giInfoInterval);
    this.popupref.instance['eventEmit'].subscribe((data) => {
      if (data === 'close') {
        this.loadIndexPage();
      }
    });
  }

  onLangClick = () => {
    this.firebaseAnalyticsServices.sendAction(
      FirebaseConstant.LOBBYDESKTOPHEADER['language'].eventAction,
      FirebaseConstant.LOBBYDESKTOPHEADER['language'].category,
      FirebaseConstant.LOBBYDESKTOPHEADER['language'].Label,
      FirebaseConstant.LOBBYDESKTOPHEADER['language'].catId,
      FirebaseConstant.LOBBYDESKTOPHEADER['language'].eventId
    ); /*'Click','(B) Lobby Desktop - Header', 'Languages',''*/
    //console.log('onLangClick------->')
    this.menuListQueueArr = [];
    this.addMenuToListArray(this.menuListObject.languages);
  };

  onSocialIconClick = (eve) => {
    this.onHeaderMenuClick(eve);
  };

  showLangPopup() {
    if (this.popupref) {
      this.popupref.destroy();
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      SelectLanguageLayoutDesktopComponent
    );
    this.popupref = this.viewContainerRef.createComponent(factory);
    this.popupref.instance['data'] = {
      ref: this.popupref,
      currentLanguage: this.currentLanguage,
    };
    this.popupref.instance['eventEmit'].subscribe((data) => {
      //console.log(data);
      if (data === 'close') {
        this.popupref.destroy();
      }
    });
  }

  showHistory(game) {
    const params: any = {};
    params.currentPage = '';
    params.initiatePage = this.pageName;
    params.gameName = game;
    params.currentPageNumber = 0;
    params.tabletype = this.currentTableType;
    params.seat = this.seatAvailable;
    params.currentLanguage = this.currentLanguage;
    //console.log('Show History');
    //console.log(params);
    if (this.userService.user.secretSquirrelKey != '') {
      this.showHistorySummary(params);
    } else {
      this.showHistoryDetail(params);
    }
  }

  showHistorySummary(params) {
    if (this.utilService.isDesktopView) {
      params.currentPage = PageConstant.HISTORYSUMMARY;
      this.pageNavigate(PageConstant.HISTORYSUMMARY, params);
    } else {
      params.currentPage = PageConstant.HISTORYSUMMARYCONDENSED;
      this.pageNavigate(PageConstant.HISTORYSUMMARYCONDENSED, params);
    }
  }

  showHistoryDetail(params) {
    params.currentPage = PageConstant.HISTORYDETAIL;
    params.redirectedFromPage = this.checkDeviceAndNavigate(this.pageName);
    this.pageNavigate(PageConstant.HISTORYDETAIL, params);
  }

  closeHistory(params) {
    if (this.pageName) {
      let paramss = {};
      //console.log(this.pageName);
      if (this.pageName === PageConstant.FC21TABLES) {
        paramss = {
          type: params.tabletype,
          seat: params.seat,
        };
      }
      if (this.pageName == 'game') {
        window.close();
      } else {
        this.pageNavigate(
          params.redirectedFromPage ||
            this.checkDeviceAndNavigate(this.pageName),
          paramss
        );
      }
      //console.log("history-->params",params);
    } else {
    }
  }

  closeHistoryDetail(params: any) {
    let loc_params: any = Object.assign({}, params);
    loc_params.detail = undefined;
    loc_params.gameid = undefined;
    loc_params = JSON.parse(JSON.stringify(loc_params));
    if (this.userService.user.secretSquirrelKey != '') {
      this.showHistorySummary(loc_params);
    } else {
      this.closeHistory(params);
    }
  }
  /**
   * method follow to callGIInfo
   * @param response
   */
  callGIInfoDataUpdate = (response) => {
    this.betLimitService.setCurrencyCodeAndSymbol(response.user_currency_code);
    this.userBalance = response.real_user_balance;
    this.userService.user.funUserBalance = response.fun_user_balance;
    this.userService.user.casinoId = response.casino_id;
    this.funUserBalance = response.fun_user_balance;
    this.userService.user.fun_user_exist = response.fun_user_exist;
    this.userService.user.isFlyLogin = response.flylogin;
    this.userService.user.reloadURL = response.reloadURL
      ? response.reloadURL
      : undefined;
    this.userService.user.first_name = response.first_name;
    this.userService.user.player_isblocked = response.player_isblocked;
    this.userService.user.isQueuedPlayer = response.isQueuedPlayer;
    this.userService.user.casinoId = response.casino_id;
    this.fun_user_exist = response.fun_user_exist;
    this.userService.user.userId = response.user_id;
    this.userService.user.usertypecode = response.usertypecode;
    this.userService.user.fun_user_game_pending =
      response.fun_user_game_pending;
    this.usertypecode = response.usertypecode;
    this.userCurrencyCode = response.user_currency_code;

    //console.log("this.funUserBalance",this.funUserBalance);
    //console.log("this.fun_user_exist",this.fun_user_exist);
    //console.log("this.usertypecode",this.usertypecode);
    //console.log('Load Game:::: ', gameName, gameFeature, betLimitId);

    if (Settings?.appSettings?.checkRelaxCasinoidArray === undefined) {
      console.log(
        'Settings.appSettings.checkRelaxCasinoidArray is undefined. Redirecting to homepage'
      );
      const snapshotUrl = this.router.routerState.snapshot.url;
      const rerouteIdx = snapshotUrl.indexOf('/fcg?');
      const rerouteUrl = snapshotUrl.substring(rerouteIdx);
      this.router.navigateByUrl(rerouteUrl);
      return;
    }

    if (
      Settings.appSettings.checkRelaxCasinoidArray.indexOf(
        this.userService.user.casinoId
      ) != -1
    ) {
      this.userService.user.isRelaxgame = true;
      if (!this.userService.user.isRelaxConfigDone) {
        this.userService.relaxConfiguration(
          'lobbyConfig',
          this.userCurrencyCode
        );
      }
    } else {
      this.userService.user.isRelaxgame = false;
    }
    //console.log('this.userService.user.isQueuedPlayer',this.userService.user.isQueuedPlayer, this.isMenuLoaded);
    if (
      this.userService.user.isQueuedPlayer &&
      this.isFileDownloaded &&
      this.isMenuLoaded
    ) {
      //console.log('this.userService.user.isQueuedPlayer',this.userService.user.isQueuedPlayer);
      this.betLimitService.makeQueuedUserRedirectToLD().subscribe((limits) => {
        if (limits) {
          this.receiveLiveDealerQueuedUser(limits, true);
        }
      });
    }
    //console.log('Settings.appSettings.checkViasinoCasinoidArray',Settings.appSettings.checkViasinoCasinoidArray)
    if (
      Settings.appSettings.checkViasinoCasinoidArray.indexOf(
        this.userService.user.casinoId
      ) != -1
    ) {
      this.lobbyLoadingInsideViasino = true;
    } else {
      this.lobbyLoadingInsideViasino = false;
    }

    if (response.rchistoryurl != undefined) {
      this.userService.user.rchistoryurl = response.rchistoryurl;
    }
    if (response.fullscreen != undefined) {
      this.userService.user.fullscreen = response.fullscreen;
    }
    if (response.rciframeurl != undefined) {
      this.userService.user.rciframeurl = response.rciframeurl;
    }
    if (response.rcinterval != undefined) {
      this.userService.user.rcinterval = response.rcinterval;
    }
    if (response.rcelapsed != undefined) {
      this.userService.user.rcelapsed = response.rcelapsed;
    }
    if (response.rcenable != undefined) {
      this.userService.user.rcenable = response.rcenable;
    }
  };
  /**
   * method loadGame--
   * @param gameName
   * @param gameFeature
   * @param betLimitId
   * @param seatAvailable //5,3,2,1
   * @param newTable
   */
  loadGame(
    gameName,
    gameFeature,
    betLimitId,
    seatAvailable,
    roomId,
    newTable = 0,
    isTableAvailable?
  ) {
    // console.log(
    //   'loadGame---------->',
    //   gameName,
    //   gameFeature,
    //   betLimitId,
    //   seatAvailable,
    //   newTable,
    //   isTableAvailable
    // );
    $('body').attr('style', 'cursor: wait !important;');
    if (this.giInfoInterval) {
      clearInterval(this.giInfoInterval);
    }

    if (gameFeature === FeatureConstant.LIVECASINO) {
      seatAvailable = 5;
    }
    if (gameName == PageConstant.FCB) {
      seatAvailable = 1;
    }

    if (!this.isLocalEnv) {
      this.userService.user.isGameStarted = true;
      this.displayLoadGameAnimation = true;
      this.giInfoService.callGIInfo().subscribe((response) => {
        //console.log(response);
        if (response.respond === true) {
          this.callGIInfoDataUpdate(response);
          const gameType =
            gameFeature === GameTypeConstant.LIVEDEALER
              ? GameTypeConstant.LIVEDEALER
              : GameTypeConstant.RNG;
          if (!this.isLocalEnv) {
            this.utilService.setReDirectURL(
              this.pageName,
              this.currentTableType,
              this.seatAvailable
            );
            this.loadGameService.loadGame(
              gameName,
              gameType,
              betLimitId,
              seatAvailable,
              roomId,
              newTable
            );
          }
        } else {
          this.loadIndexPage();
        }
      });
    }
  }

  loadWebsite(data) {
    this.loadGameService.loadWebsite(data);
  }

  onLogOutClick = (event) => {
    //console.log('On Log Out');
    this.loadGameService.logout();
    //console.log(this.userService.user.isFlyLogin);
    //console.log(this.pageName);
    if (this.utilService.isDesktopView) {
      this.menuState1 = 'outstatedesktop';
      this.menuState2 = 'outstatedesktop';
    } else {
      this.menuState1 = 'outstateright';
      this.menuState2 = 'outstateright';
    }
    this.pageName = PageConstant.FCG;
    this.removeMenu();
    if (this.giInfoInterval) {
      clearInterval(this.giInfoInterval);
    }
    if (this.pageName === PageConstant.FCG) {
      if (!this.isLocalEnv) {
        if (!this.userService.user.isFlyLogin) {
          this.giInfoService.sessionOut().subscribe((response) => {
            //console.log(response);
            this.loadIndexPage();
          });
        }
      } else {
        this.loadIndexPage();
      }
    } else {
      if (this.utilService.isDesktopView) {
        this.pageNavigate(PageConstant.FCG);
        if (FirebaseConstant.LOBBYDESKTOPHEADER['fcg']) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.LOBBYDESKTOPHEADER['fcg'].eventAction,
            FirebaseConstant.LOBBYDESKTOPHEADER['fcg'].category,
            FirebaseConstant.LOBBYDESKTOPHEADER['fcg'].Label,
            FirebaseConstant.LOBBYDESKTOPHEADER['fcg'].catId,
            FirebaseConstant.LOBBYDESKTOPHEADER['fcg'].eventId
          );
        }
      } else {
        this.pageNavigate(PageConstant.FCGMOBILE);
        if (FirebaseConstant.LOBBYMOBILEHEADER['fcg']) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.LOBBYMOBILEHEADER['fcg'].eventAction,
            FirebaseConstant.LOBBYMOBILEHEADER['fcg'].category,
            FirebaseConstant.LOBBYMOBILEHEADER['fcg'].Label,
            FirebaseConstant.LOBBYMOBILEHEADER['fcg'].catId,
            FirebaseConstant.LOBBYMOBILEHEADER['fcg'].eventId
          );
        }
      }
    }
  };

  onHeaderMenuIconClick = (eve) => {
    //console.log('header click', eve);
    switch (eve.toString()) {
      case 'menu':
        this.onMenuIconClick(eve);
        if (eve == 'menu') {
          if (this.utilService.isDesktopView) {
            this.firebaseAnalyticsServices.sendAction(
              FirebaseConstant.LOBBYDESKTOPHEADER['menu'].eventAction,
              FirebaseConstant.LOBBYDESKTOPHEADER['menu'].category,
              FirebaseConstant.LOBBYDESKTOPHEADER['menu'].Label,
              FirebaseConstant.LOBBYDESKTOPHEADER['menu'].catId,
              FirebaseConstant.LOBBYDESKTOPHEADER['menu'].eventId
            );
          } else {
            this.firebaseAnalyticsServices.sendAction(
              FirebaseConstant.LOBBYMOBILEHEADER['menu'].eventAction,
              FirebaseConstant.LOBBYMOBILEHEADER['menu'].category,
              FirebaseConstant.LOBBYMOBILEHEADER['menu'].Label,
              FirebaseConstant.LOBBYMOBILEHEADER['menu'].catId,
              FirebaseConstant.LOBBYMOBILEHEADER['menu'].eventId
            );
            /*this.firebaseAnalyticsServices.sendAction('Click','Lobby Mobile - Header','Menu');*/
          }
        }
        break;
      default:
        this.onHeaderMenuClick(eve);
        break;
    }
  };

  onMenuIconClick = (event) => {
    console.log('onMenuIconClick');
    console.log(this.pageName);
    this.currentScrollPosition = window.pageYOffset + 1000;
    this.menuListQueueArr = [];
    let menuObj = this.menuListObject.menu;
    switch (this.pageName) {
      case PageConstant.FC21:
      case PageConstant.FC21MOBILE:
      case PageConstant.FCG:
      case PageConstant.FCGMOBILE:
      case PageConstant.FCB:
      case PageConstant.FCBMOBILE:
        menuObj = this.menuListObject.menu;
        break;
      case PageConstant.FC21TABLES:
      case PageConstant.FC21TABLESMOBILE:
      case PageConstant.FCBTABLES:
      case PageConstant.FCBTABLESMOBILE:
        menuObj = this.menuListObject.selecttable;
        break;
    }
    this.addMenuToListArray(menuObj);
    // this.isDisableClick = false;
    //console.log('this.currentScrollPosition',this.currentScrollPosition);
  };

  addMenuToListArray = (menu) => {
    //console.log('addMenuToListArray', menu);
    this.removeAllMenu = false;
    this.menuListQueueArr.push(menu);
    this.scrollListen();
    this.addEventListenerScroll();
    const len = this.menuListQueueArr.length;
    /*if (this.utilService.isDesktopView) {*/
    this.menuState1 = 'outstatedesktop';
    this.menuState2 = 'outstatedesktop';
    /*   } else {
         this.menuState1 = 'outstate';
         this.menuState2 = 'outstate';
       }*/
    switch (len) {
      case 1:
        this.menuListObj1 = this.menuListQueueArr[0];
        this.menuListObj2 = undefined;
        this.menuState1 = 'enterfromright';
        /*  if (this.utilService.isDesktopView) {*/
        this.menuState2 = 'outstatedesktop';
        /*} else {
          this.menuState2 = 'outstate';
        }*/
        break;
      default:
        this.menuListObj1 = this.menuListQueueArr[len - 2];
        this.menuListObj2 = this.menuListQueueArr[len - 1];
        /*if (this.utilService.isDesktopView) {*/
        this.menuState1 = 'static';
        /*  } else {
            this.menuState1 = 'leavetoleft';
          }*/
        this.menuState2 = 'enterfromright';
        break;
    }
    this.showSlideMenu = true;
    this.showMenu = true;
  };

  removeMenuToListArray = () => {
    const len = this.menuListQueueArr.length;
    /* if (this.utilService.isDesktopView) {*/
    this.menuState1 = 'outstatedesktop';
    this.menuState2 = 'outstatedesktop';
    /*} else {
      this.menuState1 = 'outstate';
      this.menuState2 = 'outstate';
    }*/
    switch (len) {
      case 1:
        this.removeEventListenerScroll();
        this.menuListObj1 = this.menuListQueueArr[0];
        this.showSlideMenu = false;
        this.menuListObj2 = undefined;
        this.menuState1 = 'leavetoright';
        /* if (this.utilService.isDesktopView) {*/
        this.menuState2 = 'outstatedesktop';
        /*} else {
          this.menuState2 = 'outstate';
        }*/
        break;
      default:
        this.menuListObj1 = this.menuListQueueArr[len - 2];
        this.menuListObj2 = this.menuListQueueArr[len - 1];
        /* if (this.utilService.isDesktopView) {*/
        this.menuState1 = 'static';
        this.menuState2 = 'leavetoright';
        /* } else {

           this.menuState1 = 'enterfromleft';
           this.menuState2 = 'leavetoright';
         }*/
        break;
    }
    this.menuListQueueArr.pop();
  };

  menuSlideAnimationDone = (event) => {
    if (
      this['menuState' + event] === 'enterfromright' ||
      this['menuState' + event] === 'enterfromleft'
    ) {
      /* if (this.utilService.isDesktopView) {*/
      this['menuState' + event] = 'static';
      /*} else {
        this['menuState' + event] = 'nostate';
      }*/
    }
    if (
      this['menuState' + event] === 'leavetoright' ||
      this['menuState' + event] === 'leavetoleft'
    ) {
      /* if (this.utilService.isDesktopView) {*/
      this['menuState' + event] = 'outstatedesktop';
      /* this.slideAnimationDone(null);*/
      /* } else {
         this['menuState' + event] = 'outstatedesktop';
         /!*this.slideAnimationDone(null);*!/
       }*/
    }
    if (
      this.stateValFav === 'enterfromright' ||
      this.stateValFav === 'enterfromleft'
    ) {
      this.stateValFav = 'static';
    }
    if (
      this.stateValFav === 'leavetoright' ||
      this.stateValFav === 'leavetoleft'
    ) {
      this.stateValFav = 'outstatedesktop';
    }

    if (
      this.stateValBetLimit === 'enterfromright' ||
      this.stateValBetLimit === 'enterfromleft'
    ) {
      this.stateValBetLimit = 'static';
    }
    if (
      this.stateValBetLimit === 'leavetoright' ||
      this.stateValBetLimit === 'leavetoleft'
    ) {
      this.stateValBetLimit = 'outstatedesktop';
    }
    this.slideAnimationDone(event);
  };

  addEventListenerScroll() {
    /*if (this.utilService.isDesktopView) {*/
    document.body.style.overflow = 'auto';
    /* } else {
       document.body.style.overflow = 'hidden';
     }*/
    document.body.style.touchAction = 'none';
    window.addEventListener('scroll', this.scrollListen);
  }

  removeEventListenerScroll() {
    document.body.style.overflow = 'auto';
    document.body.style.touchAction = 'manipulation';
    window.removeEventListener('scroll', this.scrollListen);
  }

  scrollListen = () => {
    // //console.log('window.pageYOffset');
    // window.scrollTo(0, window.pageYOffset);
    // alert(window.pageYOffset);
    this.currentScrollPosition = window.pageYOffset;
    //console.log('this.currentScrollPosition',this.currentScrollPosition);
  };

  onSelectState = (event) => {
    this.removeMenuToListArray();
  };

  onSelectMenuOnList = (event) => {
    const homeurl = this.utilService.getHomeUrlFromStorage();

    let currentEvent;
    if (event.name) {
      currentEvent = event.name;
    } else {
      currentEvent = event;
    }

    let getCurrentLanguage;
    if (event.lang === 'languages') {
      currentEvent = 'languagetranslat';
      getCurrentLanguage = event.data;
    }
    this.isShowLobby = true;
    this.removeEventListenerScroll();
    switch (currentEvent.toString()) {
      case 'home':
        this.menuState1 = 'leavetoright';
        if (this.utilService.isDesktopView) {
          this.menuState2 = 'outstatedesktop';
        } else {
          this.menuState2 = 'outstate';
        }
        if (this.utilService.isDesktopView) {
          this.pageNavigate(PageConstant.FCG);
        } else {
          this.pageNavigate(PageConstant.FCGMOBILE);
        }
        this.removeMenu();
        break;
      case 'history_fc21':
        this.showHistory('fc21');
        break;
      case 'tutorials':
        if (this.gameNameStr == GameConstant.FC21) {
          this.subMenuListArrValue =
            this.menuListObject[currentEvent.toString()];
          this.addMenuToListArray(this.subMenuListArrValue);
          this.utilService.loadfc21TutorialManifest();
        } else if (this.gameNameStr == GameConstant.FCB) {
          if (
            Settings.appSettings.menu[this.gameNameStr][currentEvent.toString()]
              .isComingSoon
          ) {
            this.addMenuToListArray(this.menuListObject.comingsoon);
          } else {
            this.showTutorialPopup(this.gameNameStr, 1);
            this.removeMenu();
          }
        }

        break;
      case 'logout':
        console.log('logout: homeurl ->', homeurl);
        if (homeurl && homeurl !== 'null') {
          try {
            console.log('logout: sending exitGame');
            const status = send.exitGame();
            console.log('logout: exitGame send status: ', status);
          } catch (e) {
            console.log('logout: error sending exitGame', e);
          }
          this.onLogOutClick(event);
        } else {
          console.log('logout: homeurl is missing');
          this.onLogOutClick(event);
        }
        break;
      case 'videotutorials':
        window.open(API.FULL_COLOR_GAMES_YOUTUBE, 'communityforums', '_blank');
        break;
      case 'communityforums':
        window.open(
          API.FULL_COLOR_GAMES_COMMUNITY_FORUMS,
          'communityforums',
          '_blank'
        );
        break;
      case 'fixourtranslations':
        window.open(
          API.FULL_COLOR_GAMES_FIX_OUR_TRANSLATIONS,
          'communityforums',
          '_blank'
        );
        break;
      case 'helpdesk':
        window.open(
          API.FULL_COLOR_GAMES_HELP_DESK,
          'communityforums',
          '_blank'
        );
        break;
      case 'aboutus':
        this.loadWebsite('openFullColorGames');
        break;
      case 'warnings':
        let currLang = this.translate.currentLang;
        let warningsURL = this.translate.translations[currLang].LANG01062;
        window.open(warningsURL, 'warnings', '_blank');
        break;
      /*case 'tutorials':
       this.showTutorialPopup(this.gameNameStr, 1);
       this.onClickOut(true);
       // this.loadGameService.openTutorial(this.gameNameStr, 1, this.currentLanguage);
       break;*/
      case 'quickkeys':
        let quickKeyIndex = 21;
        if (this.gameNameStr == 'fc21') {
          quickKeyIndex = 21;
        } else if (this.gameNameStr == 'fcb') {
          quickKeyIndex = 19;
        }
        if (
          Settings.appSettings.menu[this.gameNameStr][currentEvent.toString()]
            .isComingSoon
        ) {
          this.addMenuToListArray(this.menuListObject.comingsoon);
        } else {
          this.showTutorialPopup(this.gameNameStr, quickKeyIndex);
          this.removeMenu();
        }
        break;
      case 'premiumpay':
        if (
          Settings.appSettings.menu[this.gameNameStr][currentEvent.toString()]
            .isComingSoon
        ) {
          this.addMenuToListArray(this.menuListObject.comingsoon);
        } else {
          if (this.gameNameStr == 'fc21') {
            this.addMenuToListArray(this.menuListObject.premiumpay);
          } else if (this.gameNameStr == 'fcb') {
            this.showTutorialPopup(this.gameNameStr, 13);
            this.removeMenu();
          }
        }
        break;
      case 'settings':
        if (
          Settings.appSettings.menu[this.gameNameStr][currentEvent.toString()]
            .isComingSoon
        ) {
          this.addMenuToListArray(this.menuListObject.comingsoon);
        } else {
          this.subMenuListArrValue =
            this.menuListObject[currentEvent.toString()];
          this.addMenuToListArray(this.subMenuListArrValue);
        }
        break;
      /* case 'handrankdetails':
         this.addMenuToListArray(this.menuListObject.handrankdetails);
         break;*/
      case 'languagetranslat':
        //console.log('*************getCurrentLanguage*****************', getCurrentLanguage);
        if (this.pageName == PageConstant.REPORTS) {
          this.removeMenu();
          this.changeReportTimeOut = setTimeout(() => {
            this.languageChange(getCurrentLanguage);
            window.clearTimeout(this.changeReportTimeOut);
          }, 500);
          return;
        }
        this.settings.language = getCurrentLanguage;
        if (!this.isLocalEnv) {
          this.callPlayerFavoriteForSettings(true);
        } else {
          this.removeMenu();
          this.changeTimeOut = setTimeout(() => {
            this.languageChange(getCurrentLanguage);
            window.clearTimeout(this.changeTimeOut);
          }, 500);
        }
        break;
      case 'handrankdealdrawdetails':
        //console.log('handrankdealdrawdetails Btn Clicked');
        /*window.open(API.FULL_COLOR_GAMES, 'fullcolorgames', '_blank');*/
        //console.log(event);
        if (event.rankid) {
          this.menuListObject.handrankdealdrawdetails.rankid = event.rankid;
        }
        this.addMenuToListArray(this.menuListObject.handrankdealdrawdetails);
        break;
      case 'coming_soon_click':
        if (this.gameStr != '') {
          this.checkIsSecret(this.gameStr);
        }
        break;
      case 'livedealer':
      case 'private':
      case 'livecasino':
        this.navigateToSameTablePage(
          currentEvent.toString(),
          currentEvent.toString() == 'livedealer' ? 7 : 5
        );
        break;
      default:
        this.subMenuListArrValue = this.menuListObject.hasOwnProperty(
          currentEvent.toString()
        )
          ? this.menuListObject[currentEvent.toString()]
          : this.menuListObject.comingsoon;
        this.addMenuToListArray(this.subMenuListArrValue);
        break;
    }
  };

  onSelectMenuTutorialOnList = (data) => {
    //console.log('gameNameStr', this.gameNameStr);
    if (data < 19) {
      if (
        Settings.appSettings.menu[this.gameNameStr]['tutorials'].isComingSoon
      ) {
        this.showCommingSoonPopup();
      } else {
        this.removeMenu();
        this.showTutorialPopup(this.gameNameStr, data);
      }
    }
    if (data >= 19 && data <= 21) {
      if (data == 21) {
        this.onHeaderIconClick('premiumpay');
      } else if (data == 19) {
        this.onHeaderIconClick('handranks');
      } else if (data == 20) {
        this.onHeaderIconClick('handrankdealdrawdetails');
      } else {
        return;
      }
    }
  };

  checkDeviceAndNavigate(pageName) {
    if (this.utilService.isDesktopView) {
      return pageName;
    } else {
      return PageConstant[(pageName + 'mobile').toUpperCase()];
    }
  }

  onFavoritesIconClick = (eve: any) => {
    //console.log('onFavoritesIconClick Common Layout',eve);
    //console.log(this.seatAvailable);
    //console.log(this.currentTableType);
    eve.tableType = this.currentTableType;
    if (
      this.utilService.isDesktopView ||
      parseInt(eve.seatavailable + '', 10) === 1
    ) {
      eve.device = 'desktop';
    } else {
      if (
        parseInt(eve.seatavailable + '', 10) === 5 ||
        parseInt(eve.seatavailable + '', 10) === 3
      ) {
        eve.device = 'device_landscape';
      } else {
        eve.device = 'device_portrait';
      }
    }

    //console.log(eve);
    this.updateFavoriteArray(eve);
  };

  updateFavoriteArray = (data) => {
    //console.log('updateFavoriteArray',data);

    if (data.betlimitid === 0) {
      if (data.title === 'viptable') {
        return;
      }
    }
    const itemIndex = this.checkElementAvailablity(this.favoriteArray, data);
    if (itemIndex === -1) {
      this.favoriteArray.unshift(data);
    } else {
      this.favoriteArray.splice(itemIndex, 1);
    }
    if (!this.isLocalEnv) {
      this.callPlayerFavoriteForTable(true);
    } else {
      this.updateFavoritesArray('{"favorites":[]}');
    }
  };

  callPlayerFavoriteForTable(isUpdateFavTable = false) {
    const sendData: any = {};
    const favData: any = {};
    if (isUpdateFavTable) {
      favData.favorites = this.favoriteArray;
      sendData.userinfo = encodeURI(JSON.stringify(favData));
    }
    sendData.mode = 0;
    sendData.t = Date.now();
    this.giInfoService.callPlayerFavorite(sendData).subscribe((response) => {
      //console.log(response);
      if (response.result) {
        this.updateFavoritesArray(response.result);
      } else {
        this.callPlayerFavoriteForTable(true);
      }
    });
  }

  updateFavoritesArray = (favStr) => {
    //console.log('updateFavoritesArray');
    //console.log(favStr);
    let tempFavArr = [];
    tempFavArr = [...this.favoriteArray];
    this.favoriteArray = [];
    if (!this.isLocalEnv) {
      this.favoriteBetLimitIdArray = [];
      const favArr = JSON.parse(favStr).favorites
        ? JSON.parse(favStr).favorites
        : [];
      tempFavArr = [...favArr];
    }
    this.favoriteArray = [...tempFavArr];
    const len = this.favoriteArray.length;
    for (let i = 0; i < len; i++) {
      this.favoriteBetLimitIdArray.push(this.favoriteArray[i].favId);
    }
    //console.log(this.favoriteArray);
  };

  onSettingsChange = (eve) => {
    if (eve.gameName === 'fc21') {
      this.settings.fc21 = <FC21>eve;
    } else if (eve.gameName === 'fcb') {
      this.settings.fcb = <FCB>eve;
    }
    if (!this.isLocalEnv) {
      this.callPlayerFavoriteForSettings(true);
    }
  };

  buildGameInfo(gameType, betlimitid?, gameName?, roomId?) {
    //console.log(this.gameInfo);//{tabletype: 'newtable', betlimitid: 0}
    //console.log(betlimitid);//{status: 'launchGame', betlimitid: 2, gameTableName: 'LiveCasino'}
    //console.log(gameType);//livecasino                      //livedealer_fc21_true_1_7_0_true
    //console.log(this.betLimitService.fc21JSON[gameType]);//livedealer_fc21_false_undefined_undefined_0_true
    const newtable = betlimitid ? 1 : 0;
    const limitid = betlimitid
      ? betlimitid.betlimitid
      : this.gameInfo.betlimitid;
    const gameNameConst = gameName
      ? gameName
      : this.currentMenuName === GameConstant.FCB
      ? this.currentMenuName
      : GameConstant.FC21;

    //console.log("---------->buildGameInfo",gameType + '_' + gameNameConst + '_' + this.betLimitService[gameNameConst + 'JSON'][gameType].isComingSoon + '_' + limitid + '_' + this.totalAvailableSeat + '_' + newtable)
    return (
      gameType +
      '_' +
      gameNameConst +
      '_' +
      (this.utilService.isSecretCode &&
      this.betLimitService[gameNameConst + 'JSON'][gameType].isSecret
        ? false
        : this.betLimitService[gameNameConst + 'JSON'][gameType].isComingSoon) +
      '_' +
      limitid +
      '_' +
      this.totalAvailableSeat +
      '_' +
      newtable +
      '_' +
      this.betLimitService[gameNameConst + 'JSON'][gameType].isSecret +
      '_' +
      `roomId-${roomId}`
    );
  }

  checkElementAvailablity = (arra = [], data: any = undefined) => {
    let isItemAvailable = -1;
    arra.forEach((element, index) => {
      //console.log(index);
      if (element.favId === data.favId) {
        isItemAvailable = index;
      }
    });
    return isItemAvailable;
  };

  slideAnimationDone = (event) => {
    //console.log(this['menuState' + event]);
    if (this['menuState' + event] == 'outstatedesktop') {
      if (this.menuListQueueArr.length == 0) {
        this.showMenu = false;
        this.menuObj = [];
        this.menuListObj1 = undefined;
        this.menuListObj2 = undefined;
      }
    }
    if (this.removeAllMenu) {
      this.menuListQueueArr = [];
      this.menuObj = [];
      this.menuListObj1 = undefined;
      this.menuListObj2 = undefined;
    }
  };

  removeMenu = () => {
    //console.log('Remove Menu');
    if (FirebaseConstant.LOBBYDESKTOPHEADER['menuClose']) {
      this.firebaseAnalyticsServices.sendAction(
        FirebaseConstant.LOBBYDESKTOPHEADER['menuClose'].eventAction,
        FirebaseConstant.LOBBYDESKTOPHEADER['menuClose'].category,
        FirebaseConstant.LOBBYDESKTOPHEADER['menuClose'].Label,
        FirebaseConstant.LOBBYDESKTOPHEADER['menuClose'].catId,
        FirebaseConstant.LOBBYDESKTOPHEADER['menuClose'].eventId
      );
    }
    this.removeAllMenu = true;
    this.showSlideMenu = false;
    const len = this.menuListQueueArr.length;
    if (len > 1) {
      this.menuState2 = 'leavetoright';
    }
    if (len > 0) {
      this.menuState1 = 'leavetoright';
    }
    this.removeEventListenerScroll();
  };

  removeFavMenu = () => {
    if (this.showSlideFav === true) {
      if (FirebaseConstant.LOBBYDESKTOPHEADER['favoritesClose']) {
        this.firebaseAnalyticsServices.sendAction(
          FirebaseConstant.LOBBYDESKTOPHEADER['favoritesClose'].eventAction,
          FirebaseConstant.LOBBYDESKTOPHEADER['favoritesClose'].category,
          FirebaseConstant.LOBBYDESKTOPHEADER['favoritesClose'].Label,
          FirebaseConstant.LOBBYDESKTOPHEADER['favoritesClose'].catId,
          FirebaseConstant.LOBBYDESKTOPHEADER['favoritesClose'].eventId
        );
      }
      this.showSlideFav = false;
      this.stateValFav = 'leavetoright';
      this.removeEventListenerScroll();
    }
  };
  removebetLimitMenu = () => {
    this.showSlidwTableLimit = false;
    this.stateValBetLimit = 'leavetoright';
  };

  updateServiceLoadComplete(data?) {
    //console.log('updateServiceLoadComplete------>data',data);
    this.isServiceloaded = true;
    let height = document.body.clientHeight;
    //console.log('updateServiceLoadComplete Post Message: Cient Height: ' + height);
    window.parent.postMessage(['setHeight', height], '*');
  }

  // interface PopupRef { // Ensure this interface or type matches what ComponentFactoryResolver returns for 'ref'
  //     destroy: () => void;
  //     // instance?: any; // Or a more specific type for the component instance
  // }

  private setSentryTags() {
    const fcgAccessToken = sessionStorage.getItem('x-fcg-access-token');

    if (!fcgAccessToken) return;

    const accessTokenPayload = JSON.parse(atob(fcgAccessToken.split('.')[1]));

    type Tags = {
      user_id: string;
      casino_id: string;
      funuser_id: string;
      exp?: string;
      last_activity?: string;
      practice_mode?: boolean;
      now: string;
    };

    const tags: Tags = {
      user_id: accessTokenPayload.user_id,
      casino_id: accessTokenPayload.casino_id,
      funuser_id: accessTokenPayload.funuser_id,
      exp: accessTokenPayload.exp
        ? new Date(accessTokenPayload.exp * 1000).toISOString()
        : undefined,
      practice_mode: accessTokenPayload.practice_mode,
      now: new Date().toISOString(),
    };

    const lastActivityEpoch = sessionStorage.getItem(
      'x-fcg-last-activity-epoch'
    );
    if (lastActivityEpoch) {
      const lastActivityDate = new Date(parseInt(lastActivityEpoch, 10) * 1000);
      tags.last_activity = lastActivityDate.toISOString();
    }
    Sentry.setTags(tags);
  }

  // public AlertLiveDealerNoSeatAvailablePopupref: PopupRef | undefined; // Ensure this property exists and matches type

  /**
   * Dismisses the "No Seat Available" popup if it is currently displayed.
   */
  public dismissLiveDealerNoSeatAvailablePopup(): void {
    if (this.AlertLiveDealerNoSeatAvailablePopupref) {
      this.AlertLiveDealerNoSeatAvailablePopupref.destroy();
      this.AlertLiveDealerNoSeatAvailablePopupref = undefined;
      // console.log('CommonLayoutComponent: "No Seat Available" popup dismissed programmatically.');
    } else {
      // console.log('CommonLayoutComponent: "No Seat Available" popup was not active or already dismissed.');
    }
  }
  ngOnDestroy() {
    //console.log('OnDestroy');
    this.removeResizeEventHandler();
    this.isFileDownloaded = false;
    this.isServiceloaded = false;
    if (this.menuLoadCompleteSubscription) {
      this.menuLoadCompleteSubscription.unsubscribe();
    }
    if (this.giInfoInterval) {
      clearInterval(this.giInfoInterval);
    }

    if (this.changeReportTimeOut) {
      window.clearTimeout(this.changeReportTimeOut);
    }
    if (this.changeTimeOut) {
      window.clearTimeout(this.changeTimeOut);
    }
    if (this.resizeTimeOut) {
      window.clearTimeout(this.resizeTimeOut);
    }
    if (this.resizeTimeOut2) {
      window.clearTimeout(this.resizeTimeOut2);
    }
    this.menuListQueueArr = [];
    /*this.clearMenu = false;*/
    delete this.isPlayNow;
    delete this.isPlayNow;
    delete this.isMenuLoaded;
    delete this.isFileDownloaded;
    delete this.isServiceloaded;
    delete this.isLoadGame;
    delete this.isShowPlayFunFeature;
    delete this.currentLanguage;
    delete this.funGameNotAvailable;
    delete this.gameType;
    delete this.isPlayerFavoriteCalled;
    delete this.popupref;
    delete this.betLimitPopupref;
    delete this.funGameNotAvailablePopUpref;
    delete this.alertRegisterPopupref;
    delete this.alertInsufficientPopupref;
    delete this.alertCommonPopupref;
    delete this.AlertLiveDealerNoSeatAvailablePopupref;
    delete this.menuListObject;
    delete this.menuListArrValue;
    delete this.isShowLobby;
    delete this.menuListObj1;
    delete this.menuListObj2;
    delete this.menuState1;
    delete this.menuState2;
    delete this.stateValFav;
    delete this.stateValBetLimit;
    delete this.mobileTableLimitGameName;
    delete this.menuListQueueArr;
    delete this.userBalance;
    delete this.isFunPopUpScenarioEnable;
    delete this.relaxConfigureSetting;
    delete this.funUserBalance;
    delete this.fun_user_exist;
    delete this.usertypecode;
    delete this.gameMinBetDetail;
    delete this.gameStr;
    delete this.isChangePlstTOReal;
    delete this.inSufficientFund;
    delete this.isFullScreen;
    delete this.isGameTypeRealOrFunPopUpEnable;
    delete this.lobbyLoadingInsideViasino;
    delete this.gameTypeRealOrFunOption;
    delete this.userCurrencyCode;
    delete this.currentScrollPosition;
    delete this.gameName;
    delete this.gameNameStr;
    delete this.seatAvailable;
    delete this.gameInfo;
    delete this.totalAvailableSeat;
    delete this.currentPageNumber;
    delete this.showSlideMenu;
    delete this.showSlideFav;
    delete this.showMenu;
    delete this.removeAllMenu;
    delete this.showSlidwTableLimit;
    delete this.showVIPPopup;
    delete this.gameDetailsStateVal;
    delete this.receiveLiveDelaerQueuedUserEvent;
    delete this.isPopUpVisible;
  }
}
